
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("aN4LZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9245a40e4559b38$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5RW99 = parcelRequire("5RW99");

var $cRsK6 = parcelRequire("cRsK6");

var $gy5H8 = parcelRequire("gy5H8");
function $d9245a40e4559b38$var$AppSwitcher() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cRsK6.TopLevelErrorBoundary), {
        id: (0, $5RW99.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gy5H8.AppSwitcherTrigger), null));
}
var $d9245a40e4559b38$export$2e2bcd8739ae039 = $d9245a40e4559b38$var$AppSwitcher;

});
parcelRegister("cRsK6", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $3d19846c898db570$export$b70f1d8bd509b358);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

const $3d19846c898db570$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $eJOHy.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: `${(0, $0c5166c52045dbc3$export$4766f0c4b6fe35dc)}.${id}`,
        packageName: (0, $0c5166c52045dbc3$export$b8b9d90f9e5bd72b),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});
const $0c5166c52045dbc3$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $0c5166c52045dbc3$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $0c5166c52045dbc3$export$9934c8d98fd9e572 = 'atlassianSwitcher';


parcelRegister("gy5H8", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherTrigger", () => $3e4e40eb05838d12$export$dc8723dff0e69fcb);

var $eJOHy = parcelRequire("eJOHy");

var $dIoeE = parcelRequire("dIoeE");


var $5RW99 = parcelRequire("5RW99");

var $gOfBc = parcelRequire("gOfBc");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lHlwJ = parcelRequire("lHlwJ");

var $7jTnu = parcelRequire("7jTnu");

var $8GjHG = parcelRequire("8GjHG");

var $eMKWj = parcelRequire("eMKWj");

var $hZvWR = parcelRequire("hZvWR");
function $3e4e40eb05838d12$export$dc8723dff0e69fcb() {
    const [isOpen, { on: openMenu, off: closeMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).APP_SWITCHER);
    const triggerAnalytics = (0, $dIoeE.useNavigationItemAnalytics)({
        navigationItemId: (0, $0c5166c52045dbc3$export$9934c8d98fd9e572)
    });
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    (0, $lHlwJ.useCrossJoinNudges)(!(0, $7jTnu.fg)('groot-1154-cjn-global-home'));
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            isOpen: isOpen,
            onClose: closeMenu,
            onOpen: onOpen
        }), [
        isOpen,
        closeMenu,
        onOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $8GjHG.AppSwitcherIntegrationEntrypoint), entryPointParams);
    const entrypointRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eMKWj.AppSwitcherPlaceholderButton), {
        onOpen: onOpen,
        ref: entrypointRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "app-switcher-content",
        packageName: "jira-navigation-apps-topnav4-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZvWR.AppSwitcherPlaceholderWithLoadingPopup), null),
        errorFallback: "flag",
        runtimeProps: entryPointParams
    }));
}

});
parcelRegister("dIoeE", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $83dfceb6ad9d0bb5$export$444d136efe970fd3);

var $eJOHy = parcelRequire("eJOHy");

var $idGJk = parcelRequire("idGJk");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
function $83dfceb6ad9d0bb5$export$444d136efe970fd3({ navigationItemId: navigationItemId }) {
    const { isVisible: isVisible } = (0, $idGJk.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
}

});

parcelRegister("lHlwJ", function(module, exports) {

$parcel$export(module.exports, "CrossJoinNudges", () => $39900d9eaea5ee9b$export$40390e43fcc876d);
$parcel$export(module.exports, "useCrossJoinNudges", () => $39900d9eaea5ee9b$export$b73ba4b3997f9abe);
$parcel$export(module.exports, "useCrossJoinNudgeYourWorkEligibility", () => $39900d9eaea5ee9b$export$1708bc6112f5b6aa);
$parcel$export(module.exports, "CrossJoinNudgeYourWork", () => $39900d9eaea5ee9b$export$eb1ab086083a0ea3);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $b9nqM = parcelRequire("b9nqM");

var $kfvK2 = parcelRequire("kfvK2");
var $83DiZ = parcelRequire("83DiZ");

var $epTsa = parcelRequire("epTsa");

var $2UBs9 = parcelRequire("2UBs9");

var $9yo90 = parcelRequire("9yo90");

var $2cfd4 = parcelRequire("2cfd4");

var $1KdDN = parcelRequire("1KdDN");

var $iaIqW = parcelRequire("iaIqW");

var $8Ujbi = parcelRequire("8Ujbi");

var $ljWHg = parcelRequire("ljWHg");

var $cYLBX = parcelRequire("cYLBX");

var $lIThU = parcelRequire("lIThU");

var $2G4e8 = parcelRequire("2G4e8");

var $hQEY6 = parcelRequire("hQEY6");

var $d2DJQ = parcelRequire("d2DJQ");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $cAkJK = parcelRequire("cAkJK");

var $4HT7U = parcelRequire("4HT7U");

var $dK92f = parcelRequire("dK92f");

var $gnRyQ = parcelRequire("gnRyQ");

var $aruII = parcelRequire("aruII");

var $blDud = parcelRequire("blDud");

var $5Ilbg = parcelRequire("5Ilbg");

var $97hJ3 = parcelRequire("97hJ3");

var $47sip = parcelRequire("47sip");
const $39900d9eaea5ee9b$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $39900d9eaea5ee9b$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $39900d9eaea5ee9b$var$MAX_FEATURE_VISIT_COUNT = 3;
const $39900d9eaea5ee9b$export$40390e43fcc876d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "JiraCrossJoinNudges",
        teamName: "groot",
        packageName: "jiraCrossJoinNudges"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($39900d9eaea5ee9b$var$CrossJoinNudgesWithoutErrorBoundary, null));
};
const $39900d9eaea5ee9b$var$CrossJoinNudgesWithoutErrorBoundary = ()=>{
    $39900d9eaea5ee9b$export$b73ba4b3997f9abe(true);
    return null;
};
const $39900d9eaea5ee9b$export$b73ba4b3997f9abe = (execNudge = true)=>{
    const getJpdCrossJoinNudgeEligibility = $39900d9eaea5ee9b$export$cf17b7d2f952c993();
    const showConfluenceCrossJoinNudge = $39900d9eaea5ee9b$export$83876d794dc56d4f();
    const showJpdCrossJoinNudge = $39900d9eaea5ee9b$export$b59148260d6e0135();
    (0, $eJOHy.useEffect)(()=>{
        if (execNudge) getJpdCrossJoinNudgeEligibility().then((isEligible)=>isEligible ? showJpdCrossJoinNudge() : showConfluenceCrossJoinNudge());
    }, [
        getJpdCrossJoinNudgeEligibility,
        showConfluenceCrossJoinNudge,
        showJpdCrossJoinNudge,
        execNudge
    ]);
};
const $39900d9eaea5ee9b$export$83876d794dc56d4f = ()=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const getNudgeRecommendations = (0, $d2DJQ.useNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const cloudId = (0, $kEUB1.useCloudId)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $39900d9eaea5ee9b$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $blDud.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const { getNudgeState: getNudgeStateV2a, setNudgeDismissed: setNudgeDismissedV2a } = (0, $2G4e8.useNudgeStateV2a)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const isYourWorkRoute = (0, $kfvK2.useIsActiveRoute)('your-work');
    const [llmExperimentConfig, fireLlmExperimentExposure] = (0, $epTsa.UNSAFE_noExposureExp)('grw-1755-growth-exp-jira-cjn-llm');
    const locale = (0, $2cfd4.useLocale)();
    const requestAccessService = (0, $7jTnu.fg)('expansion_services_in_cjn') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2UBs9.useService)((0, $9yo90.requestAccess)) : null;
    return (0, $eJOHy.useCallback)(async ()=>{
        const startTimestamp = Date.now();
        try {
            if (isYourWorkRoute) return;
            if (!licensedProducts.confluence) return;
            if ((0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesConfluence', 30)) return;
            if (await (0, $dWhgU.isSiteOptedOut)(cloudId)) {
                (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return;
            }
            const userHasProductAccess = await (0, $hQEY6.hasProductAccess)('confluence', cloudId);
            if (userHasProductAccess) return;
            const userCanRequestAccessToConfluence = await (0, $lUO6r.fetchIsRequestAccessCapable)('confluence', cloudId);
            if (!userCanRequestAccessToConfluence) return;
            if (!await (0, $fWKBM.isSite7DaysOld)('confluence', cloudId)) return;
            if (await (0, $gnRyQ.isNewActiveUser)(cloudId, userId)) return;
            // Since V2A Rollout to 100%, all nudge will use V2A Logic
            if (await getNudgeStateV2a() === 'DISMISSED') return;
            const featureVisitedCount = await (0, $ljWHg.getFeatureVisitedCount)(userId);
            const isEnglishLocale = locale && locale.startsWith('en');
            // NOTE: This AA test shouldn't be run in parallel with the AB 'grw-1755-growth-exp-jira-cjn-llm' experiment. Ensure flags are properly coordinated in statsig.
            if (isEnglishLocale && (0, $7jTnu.fg)('grw-1755-growth-exp-jira-cjn-llm-aa')) (async function() {
                try {
                    if (!(0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesLLMAA', 7)) {
                        const collaborators = await getFilteredCollaborators();
                        const hasNoCollaborators = collaborators.length === 0;
                        if (!hasNoCollaborators) // user is part of v2a
                        return;
                        await (0, $dK92f.generateCJNContent)();
                        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
                            flagKey: 'grw-1755-growth-exp-jira-cjn-llm-aa',
                            featureVisitedCount: featureVisitedCount,
                            msSinceStart: startTimestamp - Date.now()
                        });
                    }
                } catch (error) {
                // We're running an AA test, so there's no user-facing error handling
                // The error is already captured in analytics
                }
            })();
            if (featureVisitedCount >= $39900d9eaea5ee9b$var$MAX_FEATURE_VISIT_COUNT) return;
            const onSubmit = async ()=>{
                try {
                    let accessStatus;
                    if (requestAccessService && (0, $7jTnu.fg)('expansion_services_in_cjn')) {
                        const serviceResult = await requestAccessService({
                            product: 'confluence',
                            integration: 'crossJoinNudgesConfluence'
                        });
                        if (serviceResult.error) {
                            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesConfluence', serviceResult.error);
                            throw serviceResult.error;
                        }
                        accessStatus = serviceResult.result;
                    } else accessStatus = await (0, $iaIqW.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesConfluence', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('confluence');
                } catch  {
                    showErrorFlag('confluence');
                }
            };
            const collaborators = await getFilteredCollaborators();
            const hasNoCollaborators = collaborators.length === 0;
            // we only need to make this api call if we know it might be used
            const llmVisitedCount = hasNoCollaborators ? await (0, $ljWHg.getFeatureVisitedCount)(userId, (0, $ljWHg.VISITED_CONFLUENCE_LLM_COUNT_KEY)) : 0;
            // we want to prevent users who have already seen a CJN from being enrolled in the LLM CJN experiment
            const userNeverSawNonLLMCJN = featureVisitedCount === 0 || llmVisitedCount > 0;
            if (isEnglishLocale && hasNoCollaborators && userNeverSawNonLLMCJN && llmExperimentConfig.get('cohort', 'Control') === 'Variation') {
                const result = await (0, $dK92f.generateCJNContent)();
                if (!result.ready) {
                    (0, $ljWHg.removeFeatureVisited)('crossJoinNudgesConfluence');
                    return;
                }
                // Only expose the LLM experiment if content generation succeeded and would actually be shown to the user
                fireLlmExperimentExposure();
                showRequestAccessPromptFlag({
                    users: collaborators,
                    onSubmit: onSubmit,
                    onOptout: setNudgeDismissedV2a,
                    snoozeFor30Days: ()=>(0, $ljWHg.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                    integration: 'crossJoinNudgesConfluence',
                    featureVisitedCount: llmVisitedCount,
                    messageParser: (0, $blDud.getLLMCJNMessageParser)({
                        title: result.title,
                        description: result.body
                    }),
                    eventAttributes: (0, $blDud.getLLMAnalyticsAttributes)({
                        users: collaborators,
                        userId: userId,
                        sessionId: sessionId.current,
                        featureVisitedCount: featureVisitedCount,
                        startTimestamp: startTimestamp,
                        companyName: result.metadata.companyName,
                        firstName: result.metadata.firstName,
                        generatedBody: result.body,
                        generatedTitle: result.title
                    })
                });
                // We do double book keeping on the visited counts to allow us to easily remove the LLM experiment if it fails and not orphan users who progressed halfway through it
                await Promise.all([
                    (0, $ljWHg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1, (0, $ljWHg.VISITED_CONFLUENCE_LLM_COUNT_KEY)),
                    (0, $ljWHg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1)
                ]);
            } else {
                if (isEnglishLocale) // Avoid over-exposing the control cohort of the LLM experiment by including non-english users
                fireLlmExperimentExposure();
                const entityId = hasNoCollaborators ? await getNudgeRecommendations() : undefined;
                showRequestAccessPromptFlag({
                    users: collaborators,
                    onSubmit: onSubmit,
                    onOptout: setNudgeDismissedV2a,
                    snoozeFor30Days: ()=>(0, $ljWHg.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                    integration: 'crossJoinNudgesConfluence',
                    featureVisitedCount: featureVisitedCount,
                    messageParser: (0, $blDud.getContextualBanditCJNMessageParser)({
                        isContextualBandit: hasNoCollaborators,
                        entityId: entityId || 'default',
                        featureVisitedCount: featureVisitedCount
                    }),
                    eventAttributes: (0, $blDud.getContextualBanditAnalyticsAttributes)({
                        users: collaborators,
                        userId: userId,
                        entityId: entityId || 'default',
                        sessionId: sessionId.current,
                        isContextualBandit: hasNoCollaborators,
                        featureVisitedCount: featureVisitedCount,
                        startTimestamp: startTimestamp
                    })
                });
                await (0, $ljWHg.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1);
            }
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeRecommendations,
        getNudgeStateV2a,
        isYourWorkRoute,
        licensedProducts.confluence,
        locale,
        push,
        requestAccessService,
        setNudgeDismissedV2a,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        userId,
        llmExperimentConfig,
        fireLlmExperimentExposure
    ]);
};
const $39900d9eaea5ee9b$export$1708bc6112f5b6aa = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { isVisited: isVisited } = (0, $ljWHg.useSnooze)('crossJoinNudgesYourWork');
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const { getNudgeState: getNudgeState } = (0, $2G4e8.useNudgeStateYourWork)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isEligible, setIsEligible] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        const checkEligibility = async ()=>{
            try {
                if (!licensedProducts.confluence) return;
                if (isVisited()) return;
                if (await (0, $dWhgU.isSiteOptedOut)(cloudId)) {
                    (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesYourWork');
                    return;
                }
                if (await getNudgeState() === 'DISMISSED') return;
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluenceAccessCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                const hasAccessToConfluence = await (0, $hQEY6.fetchCachedAccessCheck)(createAnalyticsEvent, 'confluence', cloudId, 'jiraYourWork');
                if (hasAccessToConfluence === null) return;
                if (hasAccessToConfluence) return;
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                const isRaCapable = await (0, $lUO6r.fetchCachedIsConfluenceRACapable)(createAnalyticsEvent, cloudId, 'jiraYourWork');
                if (isRaCapable === null) return;
                if (!isRaCapable) return;
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'siteAgeCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                if (!await (0, $fWKBM.isSite7DaysOld)('confluence', cloudId)) return;
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promotionalCard eligibleCheckSucceeded', {
                    touchpoint: 'jiraYourWork'
                });
                setIsEligible(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $8Ujbi.fireErrorAnalytics)('useCrossJoinNudgeYourWorkEligibility', error, {
                    cloudId: cloudId
                });
            }
        };
        checkEligibility();
    }, [
        cloudId,
        getNudgeState,
        isVisited,
        licensedProducts.confluence,
        createAnalyticsEvent
    ]);
    return isEligible;
};
const $39900d9eaea5ee9b$var$CrossJoinNudgeYourWorkWithChecks = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const { setNudgeDismissed: setNudgeDismissed } = (0, $2G4e8.useNudgeStateYourWork)();
    const { snoozeFor7Days: snoozeFor7Days, snoozeFor30Days: snoozeFor30Days, increaseVisitedCount: increaseVisitedCount } = (0, $ljWHg.useSnooze)('crossJoinNudgesYourWork');
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isDismissed, setIsDismissed] = (0, $eJOHy.useState)(false);
    const { collaborators: collaborators, isLoading: isCollaboratorsLoading } = (0, $cAkJK.useCollaborators)(true);
    const { visitedCount: visitedCount, isLoading: isVisitedCountLoading } = (0, $4HT7U.useVisitedCount)(true, 'crossJoinNudgesYourWork');
    const onDismiss = (0, $eJOHy.useCallback)(()=>{
        snoozeFor7Days();
        increaseVisitedCount(visitedCount + 1);
        setIsDismissed(true);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard dismissed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        visitedCount,
        increaseVisitedCount,
        snoozeFor7Days
    ]);
    const onSubmit = (0, $eJOHy.useCallback)(async ()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard submitted', 'crossJoinNudges');
        try {
            const accessStatus = await (0, $iaIqW.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesYourWork', createAnalyticsEvent);
            (0, $lUO6r.resetRACapableCache)();
            if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
            else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') {
                showSuccessFlag();
                setIsDismissed(true);
            } else {
                showErrorFlag('confluence');
                setNudgeDismissed();
                setIsDismissed(true);
            }
        } catch (err) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promotionalCard submitError', {
                err: err
            });
            showErrorFlag('confluence');
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showSuccessFlag,
        userId
    ]);
    const onSnooze = (0, $eJOHy.useCallback)(()=>{
        snoozeFor30Days();
        increaseVisitedCount(visitedCount + 1);
        setIsDismissed(true);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard snoozed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        visitedCount,
        increaseVisitedCount,
        snoozeFor30Days
    ]);
    const onOptOut = (0, $eJOHy.useCallback)(()=>{
        setNudgeDismissed();
        setIsDismissed(true);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard optedOut', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        setNudgeDismissed
    ]);
    let secondaryAction;
    switch(visitedCount){
        case 0:
            secondaryAction = 'none';
            break;
        case 1:
            secondaryAction = 'snooze';
            break;
        default:
            secondaryAction = 'opt-out';
    }
    const onRender = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard shown', 'crossJoinNudges', {
            secondaryAction: secondaryAction,
            collaborators: collaborators.length
        });
    }, [
        collaborators.length,
        createAnalyticsEvent,
        secondaryAction
    ]);
    const shouldShow = !isCollaboratorsLoading && !isVisitedCountLoading && !isDismissed;
    return shouldShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $47sip.CrossJoinNudgeYourWorkCard), {
        collaborators: collaborators,
        onRender: onRender,
        onDismiss: secondaryAction === 'none' ? onDismiss : onSnooze,
        onSubmit: onSubmit,
        onSnooze: secondaryAction === 'snooze' ? onSnooze : undefined,
        onOptOut: secondaryAction === 'opt-out' ? onOptOut : undefined
    }) : null;
};
const $39900d9eaea5ee9b$export$eb1ab086083a0ea3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $97hJ3.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($39900d9eaea5ee9b$var$CrossJoinNudgeYourWorkWithChecks, null));
const $39900d9eaea5ee9b$export$cf17b7d2f952c993 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const isJpdRoute = (0, $kfvK2.useIsActiveRoute)('polaris-ideas');
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            if ((0, $ljWHg.getOrUpdateFeatureVisited)('crossJoinNudgesJiraToJpd', 30)) return false;
            if (isJpdRoute) return false;
            const eligibilityResponse = await (0, $lIThU.checkJpdCrossJoinNudgeEligibility)({
                cloudId: cloudId,
                userId: userId,
                licensedProducts: licensedProducts
            });
            if (!eligibilityResponse.eligible) {
                if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $8Ujbi.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return false;
            }
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
            return false;
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent,
        isJpdRoute,
        licensedProducts
    ]);
};
const $39900d9eaea5ee9b$export$b59148260d6e0135 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $cYLBX.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $39900d9eaea5ee9b$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $blDud.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $5Ilbg.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $aruII.useRequestAccessErrorFlag)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount } = (0, $ljWHg.useSnooze)('crossJoinNudgesJiraToJpd');
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $2G4e8.useNudgeStateJiraToJpd)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const startTimestamp = Date.now();
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $iaIqW.requestAccess)('jira-product-discovery', cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            const isUserOptOut = await getNudgeState() === 'DISMISSED';
            const featureVisitedCount = await getVisitedCount();
            if (isUserOptOut || featureVisitedCount >= $39900d9eaea5ee9b$var$MAX_FEATURE_VISIT_COUNT) return;
            showRequestAccessPromptFlag({
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissed,
                snoozeFor30Days: snoozeFor30Days,
                integration: 'crossJoinNudgesJiraToJpd',
                featureVisitedCount: featureVisitedCount,
                messageParser: (0, $blDud.getJPDCJNMessageStrings),
                eventAttributes: (0, $blDud.getAnalyticsAttributes)({
                    userId: userId,
                    users: collaboratorsOnJpd,
                    featureVisitedCount: featureVisitedCount,
                    startTimestamp: startTimestamp
                })
            });
            increaseVisitedCount(featureVisitedCount + 1);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $8Ujbi.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeState,
        getVisitedCount,
        increaseVisitedCount,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor30Days,
        userId
    ]);
};

});
parcelRegister("2UBs9", function(module, exports) {

$parcel$export(module.exports, "useService", () => $97d3dd764d989814$export$6de4685a6c88b4e9);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $iHd0I = parcelRequire("iHd0I");

var $gYnSx = parcelRequire("gYnSx");

var $804Kx = parcelRequire("804Kx");

var $i1bbF = parcelRequire("i1bbF");

var $4HZCb = parcelRequire("4HZCb");
const $97d3dd764d989814$var$useEnvironmentDeps = ()=>{
    // Use product's hooks to build a bag of dependencies
    // that the product environment will provide to the services.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $804Kx.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const product = (0, $4HZCb.useJiraCurrentProduct)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    return (0, $eJOHy.useMemo)(()=>({
            createAnalyticsEvent: createAnalyticsEvent,
            fetchJSON: (0, $i1bbF.jiraFetchJson),
            getCurrentCloudId: ()=>cloudId,
            getCurrentProduct: ()=>product,
            getCurrentUserId: ()=>atlassianAccountId,
            fireErrorAnalytics: $gYnSx.default
        }), [
        createAnalyticsEvent,
        cloudId,
        product,
        atlassianAccountId
    ]);
};
const $97d3dd764d989814$export$6de4685a6c88b4e9 = (service, providedDeps)=>{
    const environmentDeps = $97d3dd764d989814$var$useEnvironmentDeps();
    const deps = (0, $eJOHy.useMemo)(()=>({
            ...environmentDeps,
            ...providedDeps
        }), [
        environmentDeps,
        providedDeps
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $iHd0I.useService)(service, deps);
};

});
parcelRegister("iHd0I", function(module, exports) {

$parcel$export(module.exports, "useService", () => $3cf8d2ededcfb03e$export$6de4685a6c88b4e9);

var $eJOHy = parcelRequire("eJOHy");

var $8wPwm = parcelRequire("8wPwm");
const $3cf8d2ededcfb03e$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $eJOHy.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$3cf8d2ededcfb03e$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $8wPwm.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $3cf8d2ededcfb03e$var$DIFFERENT = false;
const $3cf8d2ededcfb03e$var$EQUAL = true;
const $3cf8d2ededcfb03e$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $3cf8d2ededcfb03e$var$EQUAL;
    if (!prevObject || !nextObject) return $3cf8d2ededcfb03e$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $3cf8d2ededcfb03e$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $3cf8d2ededcfb03e$var$DIFFERENT;
        }
        return $3cf8d2ededcfb03e$var$EQUAL;
    }
};

});
parcelRegister("8wPwm", function(module, exports) {

$parcel$export(module.exports, "resolveService", () => $62f2ea1448721402$export$388f24d19a29b0a2);

var $i583N = parcelRequire("i583N");
function $62f2ea1448721402$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $i583N.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $62f2ea1448721402$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $62f2ea1448721402$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $62f2ea1448721402$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }

});
parcelRegister("i583N", function(module, exports) {

$parcel$export(module.exports, "isServiceWithDeps", () => $55b7790d3d3cf328$export$4094c5185600bd73);
$parcel$export(module.exports, "unimplementedAbstractService", () => $55b7790d3d3cf328$export$6e9f7b680f09bab1);
$parcel$export(module.exports, "toError", () => $55b7790d3d3cf328$export$cc3b967c039ed3e7);
const $55b7790d3d3cf328$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $55b7790d3d3cf328$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $55b7790d3d3cf328$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};

});



parcelRegister("804Kx", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $c21c35fb8e0a29fe$export$5bf35293e545f20c);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $c21c35fb8e0a29fe$var$AnalyticsWebClientTypeToJiraEventType = {
    sendTrackEvent: 'TRACK',
    sendUIEvent: 'UI',
    sendScreenEvent: 'SCREEN',
    sendOperationalEvent: 'OPERATIONAL'
};
const $c21c35fb8e0a29fe$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEventNotFireable } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useMemo)(()=>{
        const createAnalyticsEvent = (payload)=>{
            const event = createAnalyticsEventNotFireable(payload);
            // event.fire() coming from `createAnalyticsEvent` does not actually send the event in Jira,
            // so we need to patch it here, ensuring it goes throught the analytics bridge correctly
            event.fire = ()=>{
                const awcType = payload.type;
                const jiraBridgeEventType = $c21c35fb8e0a29fe$var$AnalyticsWebClientTypeToJiraEventType[awcType];
                if (!jiraBridgeEventType) return;
                (0, $gCeeo.fireAnalytics)(event, jiraBridgeEventType, payload.data);
            };
            return event;
        };
        return {
            createAnalyticsEvent: createAnalyticsEvent
        };
    }, [
        createAnalyticsEventNotFireable
    ]);
};

});

parcelRegister("i1bbF", function(module, exports) {

$parcel$export(module.exports, "jiraFetchJson", () => $ed8c3e541183e2e1$export$a1dfe802bc656913);

var $1Ozm9 = parcelRequire("1Ozm9");
const $ed8c3e541183e2e1$export$a1dfe802bc656913 = (input)=>{
    const url = input.url;
    const options = input;
    return (0, $1Ozm9.default)(url, options);
};

});

parcelRegister("4HZCb", function(module, exports) {

$parcel$export(module.exports, "useJiraCurrentProduct", () => $4ce1f4f52831212e$export$47a383c930365f5d);

var $eNgPF = parcelRequire("eNgPF");
const $4ce1f4f52831212e$export$47a383c930365f5d = ()=>{
    const productName = (0, $eNgPF.useProductName)();
    switch(productName){
        case 'core':
            return 'jira-core';
        case 'jira':
            return 'jira-software';
        case 'serviceDesk':
            return 'jira-servicedesk';
        case 'product-discovery':
            return 'jira-product-discovery';
        default:
            return 'jira-core';
    }
};

});


parcelRegister("9yo90", function(module, exports) {

$parcel$export(module.exports, "requestAccess", () => $e322d6a717699e5d$export$cd9e5995821603e1);
/**
 * This file defines the requestAccess() service.
 */ 
var $i583N = parcelRequire("i583N");

var $bfhQ2 = parcelRequire("bfhQ2");

var $dn9SV = parcelRequire("dn9SV");
// Dependencies - generally common to all RA's/joins:
const $e322d6a717699e5d$var$dependencies = {
    fetchJSON: $dn9SV.fetchJSON,
    createAnalyticsEvent: $bfhQ2.createAnalyticsEvent,
    getStargateURL: $bfhQ2.getStargateURL,
    getCurrentUserId: $bfhQ2.getCurrentUserId,
    getCurrentCloudId: $bfhQ2.getCurrentCloudId,
    getCurrentProduct: $bfhQ2.getCurrentProduct
};
const $e322d6a717699e5d$export$cd9e5995821603e1 = Object.assign($e322d6a717699e5d$var$requestAccessImpl, {
    dependencies: $e322d6a717699e5d$var$dependencies
});
async function $e322d6a717699e5d$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = `ari:cloud:${input.product}::site/${cloudId}`;
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource
            })
        });
        result = $e322d6a717699e5d$var$mapRequestAccessResponse(response, {
            resource: resource,
            userId: userId,
            ...input
        });
    } catch (error) {
        result = {
            error: (0, $i583N.toError)(error),
            ...input,
            result: null,
            resource: resource,
            userId: userId
        };
    }
    $e322d6a717699e5d$var$fireRequestAccessAnalytics({
        ...input,
        ...result
    }, context);
    return result;
}
function $e322d6a717699e5d$var$mapRequestAccessResponse(response, input) {
    return {
        error: null,
        result: response.results[input.resource],
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $e322d6a717699e5d$var$fireRequestAccessAnalytics({ error: error, product: product, result: result }, context) {
    if (!error) {
        const currentUserId = context.dependencies().getCurrentUserId();
        const attributes = {
            userAaid: currentUserId,
            actorAaid: currentUserId,
            roleName: 'product/member',
            inviteStatus: result,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            product: product
        };
        if (result === 'ACCESS_GRANTED') $e322d6a717699e5d$var$fireProductJoined(attributes, context);
        else $e322d6a717699e5d$var$fireProductAccessRequested(attributes, context);
    }
}
function $e322d6a717699e5d$var$fireProductAccessRequested(input, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSujectId: input.userAaid,
            attributes: input
        }
    }).fire();
}
function $e322d6a717699e5d$var$fireProductJoined({ userUuid: userUuid, userAaid: userAaid, roleName: roleName, sourceTenantId: sourceTenantId, sourceProduct: sourceProduct, recommendationSources: recommendationSources, product: product }, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSujectId: product,
            attributes: {
                userUuid: userUuid,
                userAaid: userAaid,
                roleName: roleName,
                sourceTenantId: sourceTenantId,
                sourceProduct: sourceProduct,
                recommendationSources: recommendationSources,
                product: product
            }
        }
    }).fire();
}

});
parcelRegister("bfhQ2", function(module, exports) {

$parcel$export(module.exports, "getStargateURL", () => $5b76c17b94208e24$export$c7904a8284e43beb);
$parcel$export(module.exports, "getCurrentCloudId", () => $5b76c17b94208e24$export$ddb1688281a3443e);
$parcel$export(module.exports, "getCurrentUserId", () => $5b76c17b94208e24$export$5ebc6cb2748e1881);
$parcel$export(module.exports, "getCurrentProduct", () => $5b76c17b94208e24$export$d01408ed6f850a64);
$parcel$export(module.exports, "createAnalyticsEvent", () => $5b76c17b94208e24$export$a48841c0475a8073);
$parcel$export(module.exports, "fireErrorAnalytics", () => $5b76c17b94208e24$export$a27c21aa3ed8f0f1);
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $i583N = parcelRequire("i583N");
const $5b76c17b94208e24$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $5b76c17b94208e24$export$ddb1688281a3443e = (0, $i583N.unimplementedAbstractService)('getCurrentCloudId');
const $5b76c17b94208e24$export$5ebc6cb2748e1881 = (0, $i583N.unimplementedAbstractService)('getCurrentUserId');
const $5b76c17b94208e24$export$d01408ed6f850a64 = (0, $i583N.unimplementedAbstractService)('getCurrentProduct');
const $5b76c17b94208e24$export$a48841c0475a8073 = (0, $i583N.unimplementedAbstractService)('createAnalyticsEvent');
const $5b76c17b94208e24$export$a27c21aa3ed8f0f1 = (0, $i583N.unimplementedAbstractService)('fireErrorAnalytics');

});

parcelRegister("dn9SV", function(module, exports) {

$parcel$export(module.exports, "fetchJSON", () => $c91c443e9923ac68$export$81bec6e38e8b706b);

var $i583N = parcelRequire("i583N");
const $c91c443e9923ac68$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $i583N.unimplementedAbstractService)('fetchJSON');

});


parcelRegister("iaIqW", function(module, exports) {

$parcel$export(module.exports, "requestAccess", () => $63e38b087ccad084$export$cd9e5995821603e1);

var $1Ozm9 = parcelRequire("1Ozm9");

var $gCeeo = parcelRequire("gCeeo");

var $8Ujbi = parcelRequire("8Ujbi");
const $63e38b087ccad084$var$URL = '/gateway/api/invitations/v1/access-requests/request';
const $63e38b087ccad084$export$cd9e5995821603e1 = async (product, cloudId, userId, integration, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    try {
        const response = await (0, $1Ozm9.default)($63e38b087ccad084$var$URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource
            })
        });
        const { results: results } = response;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $8Ujbi.fireErrorAnalytics)(integration, error);
        throw new Error(`${integration} request access error`);
    }
};

});
parcelRegister("8Ujbi", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $499c57cf6f6c3e89$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireSiteOptedOutAnalytics", () => $499c57cf6f6c3e89$export$b6a30d1aef42926f);

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
const $499c57cf6f6c3e89$export$a27c21aa3ed8f0f1 = (id, error, attributes = {})=>(0, $gYnSx.default)({
        meta: {
            id: id,
            packageName: 'jiraCrossJoinNudges'
        },
        attributes: attributes,
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
const $499c57cf6f6c3e89$export$b6a30d1aef42926f = (createAnalyticsEvent, integration)=>{
    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
        flagKey: 'NON_CONTEXTUAL_CJNS',
        ineligibilityReason: 'SITE_OPTED_OUT',
        integration: integration
    });
};

});


parcelRegister("ljWHg", function(module, exports) {

$parcel$export(module.exports, "VISITED_CONFLUENCE_LLM_COUNT_KEY", () => $85f3c48b465caa03$export$afe713ceb95e80be);
$parcel$export(module.exports, "getOrUpdateFeatureVisited", () => $85f3c48b465caa03$export$fd94e26348dead8f);
$parcel$export(module.exports, "removeFeatureVisited", () => $85f3c48b465caa03$export$fcf4f05929d7c90b);
$parcel$export(module.exports, "snoozeFeatureFor30Days", () => $85f3c48b465caa03$export$788659dbff920e5f);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $85f3c48b465caa03$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $85f3c48b465caa03$export$41554dcbb74e65ef);
$parcel$export(module.exports, "useSnooze", () => $85f3c48b465caa03$export$26ba987533188b38);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $kwi6w = parcelRequire("kwi6w");
const $85f3c48b465caa03$var$VISITED_COUNT_KEY = 'CROSS_JOIN_NUDGE_CONFLUENCE_VISITED_COUNT';
const $85f3c48b465caa03$export$afe713ceb95e80be = 'CROSS_JOIN_NUDGE_CONFLUENCE_LLM_VISITED_COUNT';
const $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $85f3c48b465caa03$var$crossJoinNudgeVisitedCache = (0, $dnU6V.createLocalStorageProvider)('cross-join-nudge-visited');
const $85f3c48b465caa03$var$visitedKeys = {
    crossJoinNudgesConfluence: 'cross.join.nudges.confluence.visited',
    crossJoinNudgesJiraToJpd: 'cross.join.nudges.jpd.visited',
    crossJoinNudgesYourWork: 'cross.join.nudges.your.work',
    crossJoinNudgesLLMAA: 'cross.join.nudges.llm.aa'
};
const $85f3c48b465caa03$export$fd94e26348dead8f = (keyName, snoozeForDays)=>{
    try {
        if ($85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)) return true;
        $85f3c48b465caa03$var$setFeatureVisited(keyName, snoozeForDays);
        // A small cohort of users have local storage completely disabled.
        // This code detects that and always returns visited=true for those users
        if (!$85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $85f3c48b465caa03$export$fcf4f05929d7c90b = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    $85f3c48b465caa03$var$crossJoinNudgeVisitedCache.remove(key);
};
const $85f3c48b465caa03$var$setFeatureVisited = (keyName, numOfDaysSnoozed)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $85f3c48b465caa03$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $85f3c48b465caa03$var$crossJoinNudgeVisitedCache.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $85f3c48b465caa03$export$7a91674e4b755c4b = (keyName)=>{
    $85f3c48b465caa03$var$setFeatureVisited(keyName, 7);
};
const $85f3c48b465caa03$export$788659dbff920e5f = (keyName)=>{
    $85f3c48b465caa03$var$setFeatureVisited(keyName, 30);
};
const $85f3c48b465caa03$export$ee4ac5fe77f8084a = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    const snoozeUntilTimestampString = $85f3c48b465caa03$var$crossJoinNudgeVisitedCache.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $85f3c48b465caa03$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $85f3c48b465caa03$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $kwi6w.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $85f3c48b465caa03$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $85f3c48b465caa03$var$VISITED_COUNT_KEY)=>{
    await (0, $kwi6w.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};
const $85f3c48b465caa03$export$26ba987533188b38 = (keyName)=>{
    const key = $85f3c48b465caa03$var$visitedKeys[keyName];
    const accountId = (0, $8q7lT.useAccountId)() || '';
    const countKey = `${key}.count`;
    return (0, $eJOHy.useMemo)(()=>({
            snoozeFor7Days: ()=>$85f3c48b465caa03$export$7a91674e4b755c4b(keyName),
            snoozeFor30Days: ()=>$85f3c48b465caa03$export$788659dbff920e5f(keyName),
            getVisitedCount: ()=>$85f3c48b465caa03$export$64c6861c3bbd89a2(accountId, countKey),
            increaseVisitedCount: (incrementedCount)=>$85f3c48b465caa03$export$41554dcbb74e65ef(accountId, incrementedCount, countKey),
            isVisited: ()=>$85f3c48b465caa03$export$ee4ac5fe77f8084a(keyName)
        }), [
        accountId,
        countKey,
        keyName
    ]);
};

});
parcelRegister("kwi6w", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $729b1eda9f96bbc5$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $729b1eda9f96bbc5$export$b3126db2ef6e34ed);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $729b1eda9f96bbc5$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $729b1eda9f96bbc5$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $729b1eda9f96bbc5$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $jGzN3.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinNudges'
            },
            error: error
        });
    }
};
const $729b1eda9f96bbc5$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $729b1eda9f96bbc5$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $jGzN3.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("cYLBX", function(module, exports) {

$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $92c00d70753dc437$export$b05786e1a14be004);
$parcel$export(module.exports, "useFilteredUsersFromCollaborationGraph", () => $92c00d70753dc437$export$4509f086e4a8422);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $lvKO5 = parcelRequire("lvKO5");

var $8NEWZ = parcelRequire("8NEWZ");
const $92c00d70753dc437$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $92c00d70753dc437$export$b05786e1a14be004 = (cloudId)=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $92c00d70753dc437$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $jGzN3.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined && en.userProfile?.account_type !== 'app' && en.userProfile?.account_status !== 'deactivated' && en.userProfile?.account_status !== 'deleted').map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};
const $92c00d70753dc437$export$4509f086e4a8422 = (cloudId, targetProduct, maxCollaborators)=>{
    const getCollaborators = $92c00d70753dc437$export$b05786e1a14be004(cloudId);
    return (0, $eJOHy.useCallback)(async ()=>{
        const collaborators = await getCollaborators();
        let collaboratorsOnTargetProduct;
        if (targetProduct === 'confluence') collaboratorsOnTargetProduct = await (0, $8NEWZ.getConfluenceUsers)(collaborators, cloudId);
        else collaboratorsOnTargetProduct = await (0, $8NEWZ.getUsersWithProductAccess)(cloudId, targetProduct, collaborators);
        return collaboratorsOnTargetProduct.slice(0, maxCollaborators);
    }, [
        cloudId,
        getCollaborators,
        targetProduct,
        maxCollaborators
    ]);
};

});
parcelRegister("8NEWZ", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUsers", () => $81b2981c4970f883$export$71bcfe5bb11155f7);
$parcel$export(module.exports, "getUsersWithProductAccess", () => $81b2981c4970f883$export$a68fadaa3a8b5e25);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $81b2981c4970f883$var$URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';
const $81b2981c4970f883$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        if (!collaborators || collaborators.length === 0) return [];
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $1Ozm9.default)($81b2981c4970f883$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $81b2981c4970f883$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $81b2981c4970f883$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};
const $81b2981c4970f883$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $81b2981c4970f883$export$a68fadaa3a8b5e25 = async (cloudId, product, collaborators)=>{
    const accountIds = collaborators.map((u)=>u.id);
    const lackingAccess = await (0, $1Ozm9.default)($81b2981c4970f883$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });
    return collaborators.filter((c)=>!lackingAccess.includes(c.id));
};

});


parcelRegister("lIThU", function(module, exports) {

$parcel$export(module.exports, "checkJpdCrossJoinNudgeEligibility", () => $d5febf352f541134$export$db3bc6af881f6bd0);

var $hQEY6 = parcelRequire("hQEY6");

var $lUO6r = parcelRequire("lUO6r");

var $fWKBM = parcelRequire("fWKBM");

var $dWhgU = parcelRequire("dWhgU");

var $gnRyQ = parcelRequire("gnRyQ");
const $d5febf352f541134$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, userId: userId, licensedProducts: licensedProducts })=>{
    if (!licensedProducts['jira-product-discovery']) return {
        eligible: false,
        ineligibilityReason: 'NO_JPD_LICENCE'
    };
    if (await (0, $dWhgU.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (!await (0, $fWKBM.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (await (0, $gnRyQ.isNewActiveUser)(cloudId, userId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_ACTIVE_USER'
    };
    if (await (0, $hQEY6.hasProductAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (!await (0, $lUO6r.fetchIsRequestAccessCapable)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};

});
parcelRegister("hQEY6", function(module, exports) {

$parcel$export(module.exports, "hasProductAccess", () => $720d3c5dda9fece8$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $720d3c5dda9fece8$export$cd2f9bc003d00b45);

var $dnU6V = parcelRequire("dnU6V");

var $1Ozm9 = parcelRequire("1Ozm9");

var $gCeeo = parcelRequire("gCeeo");
const $720d3c5dda9fece8$var$URL = '/gateway/api/permissions/permitted';
const $720d3c5dda9fece8$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $1Ozm9.default)($720d3c5dda9fece8$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $720d3c5dda9fece8$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $720d3c5dda9fece8$var$crossJoinApiCache = (0, $dnU6V.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $720d3c5dda9fece8$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $720d3c5dda9fece8$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $720d3c5dda9fece8$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            $720d3c5dda9fece8$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $720d3c5dda9fece8$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("lUO6r", function(module, exports) {

$parcel$export(module.exports, "fetchIsRequestAccessCapable", () => $22792cce0cce9606$export$c75518284e8dee24);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $22792cce0cce9606$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $22792cce0cce9606$export$5191fc85eb825b4b);

var $dnU6V = parcelRequire("dnU6V");

var $1Ozm9 = parcelRequire("1Ozm9");

var $gCeeo = parcelRequire("gCeeo");
const $22792cce0cce9606$export$c75518284e8dee24 = async (product, cloudId)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    const response = await (0, $1Ozm9.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
};
const $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $22792cce0cce9606$var$crossJoinApiCache = (0, $dnU6V.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $22792cce0cce9606$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $22792cce0cce9606$var$crossJoinApiCache.get($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $22792cce0cce9606$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $22792cce0cce9606$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $22792cce0cce9606$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        $22792cce0cce9606$var$crossJoinApiCache.set($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $22792cce0cce9606$export$5191fc85eb825b4b = ()=>{
    $22792cce0cce9606$var$crossJoinApiCache.remove($22792cce0cce9606$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});

parcelRegister("fWKBM", function(module, exports) {

$parcel$export(module.exports, "isSite7DaysOld", () => $a9d6cb12118148cb$export$23b7746c9e6ae406);

var $lctcw = parcelRequire("lctcw");
const $a9d6cb12118148cb$var$ACTIVATION_TRAITS = {
    confluence: 'confluence.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate'
};
const $a9d6cb12118148cb$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $a9d6cb12118148cb$var$findAndCheckActivationDate(product, siteTraits);
};
const $a9d6cb12118148cb$var$findAndCheckActivationDate = (product, traits)=>{
    const traitName = $a9d6cb12118148cb$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};

});

parcelRegister("dWhgU", function(module, exports) {

$parcel$export(module.exports, "isSiteOptedOut", () => $7e925e1d07159dc3$export$3475487c10c1ac17);

var $lctcw = parcelRequire("lctcw");
const $7e925e1d07159dc3$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};

});

parcelRegister("gnRyQ", function(module, exports) {

$parcel$export(module.exports, "isNewActiveUser", () => $63575b3cc2f8f421$export$b4712e67f435e1dc);

var $lFovQ = parcelRequire("lFovQ");
const $63575b3cc2f8f421$export$b4712e67f435e1dc = async (cloudId, userId)=>{
    const userTraits = await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    return $63575b3cc2f8f421$var$findAndCheckActiveDate(userTraits);
};
const $63575b3cc2f8f421$var$findAndCheckActiveDate = (traits)=>{
    const traitName = 'jira_first_active';
    const firstActiveTrait = traits.find((trait)=>trait.name === traitName);
    if (firstActiveTrait?.value) {
        const oneWeekActive = new Date(firstActiveTrait?.value.toString());
        oneWeekActive.setDate(oneWeekActive.getDate() + 7);
        const today = new Date();
        return today <= oneWeekActive;
    }
    return true;
};

});


parcelRegister("2G4e8", function(module, exports) {

$parcel$export(module.exports, "useNudgeStateV2a", () => $51c7f399587b4997$export$1721ab60f4854021);
$parcel$export(module.exports, "useNudgeStateYourWork", () => $51c7f399587b4997$export$766742495b6411cb);
$parcel$export(module.exports, "useNudgeStateJiraToJpd", () => $51c7f399587b4997$export$13bdd3f195e673d5);

var $eJOHy = parcelRequire("eJOHy");

var $8q7lT = parcelRequire("8q7lT");

var $kwi6w = parcelRequire("kwi6w");
const $51c7f399587b4997$var$getNudgeState = async (key, accountId)=>{
    if (!accountId) return 'NONE';
    const nudgeState = await (0, $kwi6w.getUserProperty)({
        accountId: accountId,
        propertyKey: key,
        defaultValue: 'NONE'
    });
    return nudgeState.value;
};
const $51c7f399587b4997$var$setNudgeDismissState = async (key, accountId)=>{
    if (!accountId) return;
    await (0, $kwi6w.setUserProperty)({
        accountId: accountId,
        propertyKey: key,
        propertyValue: 'DISMISSED'
    });
};
const $51c7f399587b4997$var$useNudgeState = (key)=>{
    const accountId = (0, $8q7lT.useAccountId)();
    return (0, $eJOHy.useMemo)(()=>({
            getNudgeState: ()=>$51c7f399587b4997$var$getNudgeState(key, accountId),
            setNudgeDismissed: ()=>$51c7f399587b4997$var$setNudgeDismissState(key, accountId)
        }), [
        accountId,
        key
    ]);
};
const $51c7f399587b4997$export$1721ab60f4854021 = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_CONFLUENCE_V2A');
const $51c7f399587b4997$export$766742495b6411cb = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_YOUR_WORK');
const $51c7f399587b4997$export$13bdd3f195e673d5 = ()=>$51c7f399587b4997$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_JPD');

});

parcelRegister("d2DJQ", function(module, exports) {

$parcel$export(module.exports, "useNudgeRecommendations", () => $8279b568d170b0bc$export$20e6812ba5f3fc39);

var $eJOHy = parcelRequire("eJOHy");

var $hHVGs = parcelRequire("hHVGs");

var $gYnSx = parcelRequire("gYnSx");

var $figsJ = parcelRequire("figsJ");

var $kEUB1 = parcelRequire("kEUB1");

var $5QB52 = parcelRequire("5QB52");
const $8279b568d170b0bc$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudge';
function $8279b568d170b0bc$export$20e6812ba5f3fc39({ sessionId: sessionId }) {
    const cloudId = (0, $kEUB1.useCloudId)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const contextResolver = (0, $eJOHy.useCallback)(()=>({
            product: 'jira',
            useCase: $8279b568d170b0bc$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $hHVGs.default)({
        contextResolver: contextResolver
    });
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const result = await getRecommendations(1, $8279b568d170b0bc$var$asEntityIdList((0, $5QB52.EntityList)));
            const { response: { data: data } = {} } = result;
            // This type assertion is necessary because useRecommendations don't support generic entityId
            const recommendedEntityId = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'recommendationFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'groot-growth'
                },
                error: error
            });
            throw new Error('Get nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
const $8279b568d170b0bc$var$asEntityIdList = (entities)=>entities.map((entity)=>({
            entityId: entity
        }));

});
parcelRegister("hHVGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $405b3c6526c7594e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $1PLEg = parcelRequire("1PLEg");

var $9F0Vk = parcelRequire("9F0Vk");

var $7AM4Y = parcelRequire("7AM4Y");

var $8C3HN = parcelRequire("8C3HN");
const $405b3c6526c7594e$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
	 * Fetch recommendations for a given context
	 */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $9F0Vk.default)(endpoint);
        const requester = new (0, $8C3HN.default)(new (0, $7AM4Y.RecommendationsRequestBroker)());
        const context = (0, $1PLEg.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $c3708eaddcf34d7d$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $405b3c6526c7594e$export$2e2bcd8739ae039 = $405b3c6526c7594e$var$useRecommendations;

});
// Events
const $c3708eaddcf34d7d$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $c3708eaddcf34d7d$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $c3708eaddcf34d7d$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $c3708eaddcf34d7d$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $c3708eaddcf34d7d$export$14b7e2c312f27acd = 'atlassian-growth-recos';

parcelRegister("1PLEg", function(module, exports) {

$parcel$export(module.exports, "isNotEmpty", () => $4c80191cf3e6dc8f$export$a079a83b07f794bf);
$parcel$export(module.exports, "getContext", () => $4c80191cf3e6dc8f$export$31553aaa555c1514);
function $4c80191cf3e6dc8f$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $4c80191cf3e6dc8f$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("9F0Vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $10f2734089221f6c$export$2e2bcd8739ae039);

var $9wJFl = parcelRequire("9wJFl");
class $10f2734089221f6c$export$2e2bcd8739ae039 extends (0, $9wJFl.default) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $10f2734089221f6c$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $10f2734089221f6c$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;

});
parcelRegister("9wJFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $64bcb20502bd499f$export$2e2bcd8739ae039);

var $1PLEg = parcelRequire("1PLEg");
class $64bcb20502bd499f$export$2e2bcd8739ae039 {
    constructor(endpoint){
        this.endpoint = endpoint;
    }
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $1PLEg.getContext)(contextResolver);
    }
}

});


parcelRegister("7AM4Y", function(module, exports) {

$parcel$export(module.exports, "RecommendationsRequestBroker", () => $1c4f57337f3932fd$export$7f19312509e0d2c0);

var $ggERV = parcelRequire("ggERV");
class $1c4f57337f3932fd$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $ggERV.RecommendationSuccessResultCreator)(response, result);
    }
}

});
parcelRegister("ggERV", function(module, exports) {

$parcel$export(module.exports, "RecommendationSuccessResultCreator", () => $1625660651dd0899$export$c02f0b31b3b527a3);

var $4M58U = parcelRequire("4M58U");
class $1625660651dd0899$export$c02f0b31b3b527a3 extends (0, $4M58U.QuerySuccessResultCreator) {
    constructor(response, data){
        super(response, data), this.response = response;
    }
    makeQueryResult() {
        return new (0, $4M58U.GraphQlQueryResult)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
}

});
parcelRegister("4M58U", function(module, exports) {

$parcel$export(module.exports, "GraphQlQueryResult", () => $cc060a79151a39e1$export$d0a1abfd57dc5018);
$parcel$export(module.exports, "NonOkQueryResultCreator", () => $cc060a79151a39e1$export$ad7cb7f4450dd7c4);
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", () => $cc060a79151a39e1$export$553722ecbbe27276);
$parcel$export(module.exports, "MissingQueryDataResultCreator", () => $cc060a79151a39e1$export$ff264bfdc9a404eb);
$parcel$export(module.exports, "QuerySuccessResultCreator", () => $cc060a79151a39e1$export$6b16771e962990ff);
class $cc060a79151a39e1$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $cc060a79151a39e1$var$QueryResultCreator {
}
class $cc060a79151a39e1$export$ad7cb7f4450dd7c4 extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $cc060a79151a39e1$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
}
class $cc060a79151a39e1$export$553722ecbbe27276 extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(errors){
        super(), this.errors = errors;
    }
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $cc060a79151a39e1$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
}
class $cc060a79151a39e1$export$ff264bfdc9a404eb extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
    makeQueryResult() {
        return new $cc060a79151a39e1$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
}
class $cc060a79151a39e1$export$6b16771e962990ff extends $cc060a79151a39e1$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}

});



parcelRegister("8C3HN", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fe69f3ee0709ae$export$2e2bcd8739ae039);

var $4M58U = parcelRequire("4M58U");

var $1nHnU = parcelRequire("1nHnU");
class $61fe69f3ee0709ae$export$2e2bcd8739ae039 {
    constructor(broker){
        this.broker = broker;
    }
    /**
	 * Fetches the response by the given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The query result
	 */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $4M58U.NonOkQueryResultCreator)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $4M58U.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $4M58U.MissingQueryDataResultCreator)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
	 * Fetches the response by tha given request from the cache or the API
	 * the cache config is optional, if not provided, the response will not be cached
	 *
	 * @param request The request to fetch the response from
	 * @param cacheConfig The cache configuration to use
	 * @returns The response from the request
	 */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $1nHnU.default).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
}

});
parcelRegister("1nHnU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1666126abcaa1a03$export$2e2bcd8739ae039);

var $drdt6 = parcelRequire("drdt6");

var $6f9Ri = parcelRequire("6f9Ri");
class $1666126abcaa1a03$export$2e2bcd8739ae039 {
    /**
	 * Returns the cache provider based on the given cache configuration
	 *
	 * @param cacheConfig The cache configuration to use
	 * @returns The cache provider
	 */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $6f9Ri.default)(cacheConfig);
        return new (0, $drdt6.default)();
    }
}

});
parcelRegister("drdt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $60050371afd45aa8$export$2e2bcd8739ae039);
class $60050371afd45aa8$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}

});

parcelRegister("6f9Ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $e402bd553ca90c06$export$2e2bcd8739ae039);

var $e0GN8 = parcelRequire("e0GN8");

var $fJj8V = parcelRequire("fJj8V");
class $e402bd553ca90c06$export$2e2bcd8739ae039 {
    /**
	 * Initialise the WebCacheStorage
	 * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
	 * @param onError a callback when any error occurs
	 */ constructor(cacheProviderConfig){
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $e0GN8.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $fJj8V.default)(this.cacheConfig);
    }
    /**
	 * Get cached response
	 */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Put response in cache
	 */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
	 * Delete cached response
	 */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
	 * Check if the cached response is expired
	 */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
	 * Compose the URL and the use case as the search params to cache the response
	 */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
	 * Get the key to store the response
	 * Interally, it hashes the request body to get a unique key
	 */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
}

});
parcelRegister("e0GN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec8dc52d6f940f42$export$2e2bcd8739ae039);
const $ec8dc52d6f940f42$var$DEFAULT_TTL = 60;
class $ec8dc52d6f940f42$export$2e2bcd8739ae039 {
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $ec8dc52d6f940f42$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
}

});

parcelRegister("fJj8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $e058fb0a0acac364$export$2e2bcd8739ae039);
class $e058fb0a0acac364$export$2e2bcd8739ae039 {
    /**
	 * Initialise the ExpiryStorage
	 */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
    /**
	 * Set the expiry date of the cached response
	 */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Get the expiry date of the cached response
	 */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
	 * Initialise the IndexedDB
	 */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
	 * Get the object store from the IndexedDB
	 */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
}

});





parcelRegister("figsJ", function(module, exports) {

$parcel$export(module.exports, "useSubProduct", () => $eeb1612abd150435$export$16aa2ad52cd8992a);
$parcel$export(module.exports, "subProductFromProjectTypeForAnalytics", () => $eeb1612abd150435$export$9243583e56af95f6);
$parcel$export(module.exports, "useSubProductForAnalytics", () => $eeb1612abd150435$export$cbfa57dd4a0c679e);

var $6nVJI = parcelRequire("6nVJI");
const $eeb1612abd150435$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $eeb1612abd150435$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $6nVJI.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $eeb1612abd150435$export$246e1e2a5c86a633(data.project.type);
};
const $eeb1612abd150435$export$9243583e56af95f6 = (projectType)=>{
    if (projectType === 'product_discovery') return 'polaris';
    return $eeb1612abd150435$export$246e1e2a5c86a633(projectType);
};
const $eeb1612abd150435$export$cbfa57dd4a0c679e = ()=>{
    const [{ data: data }] = (0, $6nVJI.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $eeb1612abd150435$export$9243583e56af95f6(data.project.type);
};

});
parcelRegister("6nVJI", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $6342ac67d1a862a1$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $6342ac67d1a862a1$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $3luhJ = parcelRequire("3luhJ");

var $9pJMP = parcelRequire("9pJMP");

var $eJrcF = parcelRequire("eJrcF");

var $kQSJV = parcelRequire("kQSJV");
const $6342ac67d1a862a1$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $3luhJ.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$export$c7066c2d215990cf = ()=>{
    const projectContext = $6342ac67d1a862a1$var$useProjectContext();
    const userBoardContext = $6342ac67d1a862a1$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $6342ac67d1a862a1$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $6342ac67d1a862a1$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$6342ac67d1a862a1$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("kQSJV", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $3546d4ad536b057d$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $3546d4ad536b057d$export$d17fffd59c7b3c60);

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $imXGf = parcelRequire("imXGf");
const $3546d4ad536b057d$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $3546d4ad536b057d$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $3546d4ad536b057d$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $7jTnu.fg)('jcs_project_type_m3')) return 0, $ln6Iy.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $ln6Iy.CORE_PROJECT;
        case 'software':
            return 0, $ln6Iy.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $ln6Iy.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $3546d4ad536b057d$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $imXGf.extractData)(projectNavInfo);
    const scope = $3546d4ad536b057d$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $3546d4ad536b057d$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $imXGf.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("5QB52", function(module, exports) {

$parcel$export(module.exports, "EntityList", () => $b173ac9c27d8f86f$export$8bb466c13870163e);
$parcel$export(module.exports, "getDynamicMessages", () => $b173ac9c27d8f86f$export$b916a1b5c615f6eb);

var $6Jmsm = parcelRequire("6Jmsm");
const $b173ac9c27d8f86f$export$8bb466c13870163e = [
    'nudgeCandidate01',
    'nudgeCandidate02',
    'nudgeCandidate03',
    'nudgeCandidate04',
    'nudgeCandidate05',
    'nudgeCandidate06',
    'nudgeCandidate07'
];
const $b173ac9c27d8f86f$var$messageVariantsKeyMap = {
    default: {
        title: 'title',
        description: 'description',
        joinButton: 'joinButton'
    },
    nudgeCandidate01: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04: {
        title: 'titleNudgeCandidate04',
        description: 'descriptionNudgeCandidate04',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05: {
        title: 'titleNudgeCandidate05',
        description: 'descriptionNudgeCandidate05',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07',
        joinButton: 'joinButtonNudgeCandidate07'
    }
};
const $b173ac9c27d8f86f$export$b916a1b5c615f6eb = (isContextualBandit, entityId)=>{
    // Handle case when entityId is unexpected
    if (!(entityId in $b173ac9c27d8f86f$var$messageVariantsKeyMap)) return undefined;
    // If v2B is not enabled we just passthrough default message keys
    const usedEntityId = isContextualBandit ? entityId : 'default';
    const titleKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[usedEntityId].title;
    const descriptionKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[usedEntityId].description;
    const joinButtonKey = $b173ac9c27d8f86f$var$messageVariantsKeyMap[usedEntityId].joinButton;
    return {
        title: (0, $6Jmsm.messages)[titleKey],
        description: (0, $6Jmsm.messages)[descriptionKey],
        joinButton: (0, $6Jmsm.messages)[joinButtonKey]
    };
};

});
parcelRegister("6Jmsm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2515efbbf3bb8f39$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2515efbbf3bb8f39$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title",
        "defaultMessage": "Your team is now using Confluence"
    },
    titleNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01",
        "defaultMessage": "Join your teammates in Confluence"
    },
    titleNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02",
        "defaultMessage": "Collaborate together in Confluence"
    },
    titleNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03",
        "defaultMessage": "Your team is working in Confluence"
    },
    titleNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04",
        "defaultMessage": "Unify your projects in Confluence"
    },
    titleNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05",
        "defaultMessage": "Bring projects together in Confluence"
    },
    titleNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06",
        "defaultMessage": "Create a single source of truth"
    },
    titleNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07",
        "defaultMessage": "Create a single source of truth"
    },
    description: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    descriptionNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01",
        "defaultMessage": "Create a single source of truth for project decisions and software documentation."
    },
    descriptionNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02",
        "defaultMessage": "Capture, consolidate, and share team knowledge, in one centralized place."
    },
    descriptionNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03",
        "defaultMessage": "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04",
        "defaultMessage": "Organize project information and sync it to Jira tasks to track and hit your goals faster."
    },
    descriptionNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05",
        "defaultMessage": "Capture information in project pages and sync to Jira tasks to track your milestones."
    },
    descriptionNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06",
        "defaultMessage": "Consolidate information in one place and sync to Jira tasks for automatic updates."
    },
    descriptionNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07",
        "defaultMessage": "Join your team in Confluence to consolidate project information in one place."
    },
    joinButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button",
        "defaultMessage": "Join your team"
    },
    joinButtonLlmGenerated: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-llm-generated",
        "defaultMessage": "Try Confluence"
    },
    joinButtonNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07",
        "defaultMessage": "Join Confluence"
    },
    remindMeLaterButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button",
        "defaultMessage": "Remind me later"
    },
    notInterestedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.not-interested-button",
        "defaultMessage": "Not interested"
    },
    urgencyTitle: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.urgency-title",
        "defaultMessage": "{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}"
    },
    titleJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-jpd-nudge",
        "defaultMessage": "Join your team in using Jira Product Discovery"
    },
    descriptionJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-jpd-nudge",
        "defaultMessage": "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    getStartedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.get-started-button",
        "defaultMessage": "Get started"
    },
    doNotShowAgainButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.do-not-show-again-button",
        "defaultMessage": "Don't show again"
    }
});

});



parcelRegister("cAkJK", function(module, exports) {

$parcel$export(module.exports, "useCollaborators", () => $1b20f5ca9736ca7a$export$1ccc4f4de0326402);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $kEUB1 = parcelRequire("kEUB1");

var $cYLBX = parcelRequire("cYLBX");

var $8NEWZ = parcelRequire("8NEWZ");
const $1b20f5ca9736ca7a$export$1ccc4f4de0326402 = (isEnrolled)=>{
    const [collaborators, setCollaborators] = (0, $eJOHy.useState)([]);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const cloudId = (0, $kEUB1.useCloudId)();
    const getCollaborators = (0, $cYLBX.useUsersFromCollaborationGraph)(cloudId);
    (0, $eJOHy.useEffect)(()=>{
        const fetch = async ()=>{
            try {
                const users = await getCollaborators();
                if (!!users && users.length !== 0) {
                    const confluenceUsers = await (0, $8NEWZ.getConfluenceUsers)(users, cloudId);
                    setCollaborators(confluenceUsers);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useCollaborators',
                        packageName: 'jiraCrossJoinNudges'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                setIsLoading(false);
            }
        };
        if (isEnrolled) fetch();
    }, [
        cloudId,
        getCollaborators,
        isEnrolled
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            collaborators: collaborators,
            isLoading: isLoading
        }), [
        collaborators,
        isLoading
    ]);
};

});

parcelRegister("4HT7U", function(module, exports) {

$parcel$export(module.exports, "useVisitedCount", () => $bb9e9e4b6efad66c$export$fb7c0ffa45d7cd29);

var $eJOHy = parcelRequire("eJOHy");

var $ljWHg = parcelRequire("ljWHg");
const $bb9e9e4b6efad66c$export$fb7c0ffa45d7cd29 = (isEnrolled, integration)=>{
    const [visitedCount, setVisitedCount] = (0, $eJOHy.useState)(0);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const { getVisitedCount: getVisitedCount } = (0, $ljWHg.useSnooze)(integration);
    (0, $eJOHy.useEffect)(()=>{
        const fetch = async ()=>{
            const count = await getVisitedCount();
            setVisitedCount(count);
            setIsLoading(false);
        };
        if (isEnrolled) fetch();
    }, [
        getVisitedCount,
        isEnrolled
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            visitedCount: visitedCount,
            isLoading: isLoading
        }), [
        visitedCount,
        isLoading
    ]);
};

});

parcelRegister("dK92f", function(module, exports) {

$parcel$export(module.exports, "generateCJNContent", () => $5cbb915e5e1affc3$export$8f35cea1f9221030);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $5cbb915e5e1affc3$var$GCGS_JIRA_SPOTLIGHT_URL = '/gateway/api/gcg/api/v1/generate/team_growth/cross_join_nudge/jira_spotlight';
const $5cbb915e5e1affc3$var$ATLASSIAN_ACCOUNT_URL = '/gateway/api/me';
const $5cbb915e5e1affc3$export$8f35cea1f9221030 = async ()=>{
    try {
        const me = await (0, $1Ozm9.default)($5cbb915e5e1affc3$var$ATLASSIAN_ACCOUNT_URL);
        const response = await (0, $1Ozm9.default)($5cbb915e5e1affc3$var$GCGS_JIRA_SPOTLIGHT_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                contact_name: me.nickname || me.name,
                domain: me.email.split('@')[1],
                product: 'confluence',
                job_title: me.extended_profile.job_title,
                department: me.extended_profile.department,
                team_type: me.extended_profile.team_type
            })
        });
        return {
            title: response.title,
            body: response.body,
            metadata: {
                companyName: response.metadata.company_name,
                firstName: response.metadata.first_name
            },
            // TODO: GROOT-1944 we should remove special handling for this scenario and just throw when we have better overall handling in place that doesn't cause a snooze
            ready: response.status !== 'PROCESSING'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'generateCJNContentFetchFailed',
                packageName: 'jiraCrossJoinNudges',
                teamName: 'groot-growth'
            },
            error: error
        });
        throw new Error('Failed to generate nudge content');
    }
};

});

parcelRegister("aruII", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessErrorFlag", () => $cd3ee887d4b607ed$export$d8e2d94eec4efe85);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $fnw8E = parcelRequire("fnw8E");

var $csiXm = parcelRequire("csiXm");

var $iOI0S = parcelRequire("iOI0S");
const $cd3ee887d4b607ed$export$d8e2d94eec4efe85 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)((product)=>{
        const id = `error-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd3ee887d4b607ed$export$e1d0d64874873c8b, {
                    ...props,
                    id: id,
                    product: product,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $cd3ee887d4b607ed$export$e1d0d64874873c8b = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $iOI0S.messages).title, {
            productDisplayName: (0, $fnw8E.ProductDisplayNames)[props.product]
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $iOI0S.messages).description), (0, $7jTnu.fg)('replace-anchor-with-link__groot-growth') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $iOI0S.messages).action)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: $cd3ee887d4b607ed$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $iOI0S.messages).action)), "."))
    });
};

});
parcelRegister("a9cht", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $3b59aa1149416ec4$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $3b59aa1149416ec4$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $3b59aa1149416ec4$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $3b59aa1149416ec4$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $3b59aa1149416ec4$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $3b59aa1149416ec4$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $3b59aa1149416ec4$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $3b59aa1149416ec4$export$a2c3479950310d7d);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$ForPaintJiraCommonFlag = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2H90P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$AfterPaintJiraCommonFlag = (0, $bQWwW.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("2H90P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $3b59aa1149416ec4$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$ForPaintFlagGroup = (0, $bQWwW.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("anv8L")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3b59aa1149416ec4$var$AfterPaintFlagGroup = (0, $bQWwW.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("anv8L")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $3b59aa1149416ec4$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$ForPaintFlagGroup, props);
const $3b59aa1149416ec4$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, props));
const $3b59aa1149416ec4$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $3b59aa1149416ec4$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $3b59aa1149416ec4$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $3b59aa1149416ec4$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $3b59aa1149416ec4$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $3b59aa1149416ec4$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $3b59aa1149416ec4$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b59aa1149416ec4$var$FlagGroupImpl, props));

});
parcelRegister("2H90P", function(module, exports) {

let $1f66969b09514848$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1f66969b09514848$var$load("ffQaD"),
    $1f66969b09514848$var$load("kvRbA"),
    $1f66969b09514848$var$load("76n7a"),
    $1f66969b09514848$var$load("l253H"),
    $1f66969b09514848$var$load("b8ahE")
]).then(()=>parcelRequire('jbDfJ'));

});

parcelRegister("anv8L", function(module, exports) {

let $78e4352d1cfc41ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $78e4352d1cfc41ca$var$load("5vCaf").then(()=>parcelRequire('1ZKRU'));

});


parcelRegister("fnw8E", function(module, exports) {

$parcel$export(module.exports, "ProductDisplayNames", () => $234d97a33b81d80d$export$46d857911d19ac95);
const $234d97a33b81d80d$export$46d857911d19ac95 = {
    confluence: 'Confluence',
    'jira-product-discovery': 'Jira Product Discovery'
};

});

parcelRegister("csiXm", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $28da6ed710c628f5$export$567fc7097e064344);
let $28da6ed710c628f5$var$id = 0;
const $28da6ed710c628f5$export$567fc7097e064344 = ()=>{
    $28da6ed710c628f5$var$id += 1;
    return String($28da6ed710c628f5$var$id);
};
function $28da6ed710c628f5$export$e86e19342bc4850e(operation, ms) {
    const startTime = Date.now();
    const timeoutPromise = new Promise((resolve)=>{
        setTimeout(()=>{
            resolve({
                timedOut: true,
                result: null,
                elapsedMs: Date.now() - startTime
            });
        }, ms);
    });
    const operationPromise = operation().then((result)=>({
            timedOut: false,
            result: result,
            elapsedMs: Date.now() - startTime
        }));
    return Promise.race([
        operationPromise,
        timeoutPromise
    ]);
}

});

parcelRegister("iOI0S", function(module, exports) {

$parcel$export(module.exports, "messages", () => $66d518c3cbacea68$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $66d518c3cbacea68$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-error-flag.title",
        "defaultMessage": "We couldn't add you to {productDisplayName}"
    },
    description: {
        "id": "cross-join-nudges.request-access-error-flag.description",
        "defaultMessage": "Try again in a few minutes. If you still aren't able to join, "
    },
    action: {
        "id": "cross-join-nudges.request-access-error-flag.action",
        "defaultMessage": "contact support"
    }
});

});


parcelRegister("blDud", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessPromptFlag", () => $b205f495b5e2eb08$export$233a6a0aca8c9091);
$parcel$export(module.exports, "getAnalyticsAttributes", () => $b205f495b5e2eb08$export$e748b6351ba5f204);
$parcel$export(module.exports, "getContextualBanditAnalyticsAttributes", () => $b205f495b5e2eb08$export$53c813e9a54d378a);
$parcel$export(module.exports, "getLLMAnalyticsAttributes", () => $b205f495b5e2eb08$export$882b0d75f031b08b);
$parcel$export(module.exports, "getContextualBanditCJNMessageParser", () => $b205f495b5e2eb08$export$7e2ad46880c00991);
$parcel$export(module.exports, "getJPDCJNMessageStrings", () => $b205f495b5e2eb08$export$77b0d0ed99f701d0);
$parcel$export(module.exports, "getLLMCJNMessageParser", () => $b205f495b5e2eb08$export$d9d7a49d4bfff37f);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $bILK0 = parcelRequire("bILK0");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $5QB52 = parcelRequire("5QB52");

var $csiXm = parcelRequire("csiXm");

var $6Jmsm = parcelRequire("6Jmsm");

var $b6Mjq = parcelRequire("b6Mjq");
const $b205f495b5e2eb08$export$233a6a0aca8c9091 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)(({ users: users, onOptout: onOptout, onSubmit: onSubmit, snoozeFor30Days: snoozeFor30Days, integration: integration, eventAttributes: eventAttributes, messageParser: messageParser, featureVisitedCount: featureVisitedCount = 0 })=>{
        const id = `request-access-${(0, $csiXm.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        const submit = async ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', integration, eventAttributes);
            dismissTheFlag();
            await onSubmit();
        };
        const dismiss = ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', integration, eventAttributes);
            dismissTheFlag();
        };
        const dismissAndOptout = ()=>{
            dismiss();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag optedOut', integration, eventAttributes);
            onOptout();
        };
        const dismissAndSnooze = ()=>{
            dismissTheFlag();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, eventAttributes);
            snoozeFor30Days();
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', integration, eventAttributes);
        const cjnMessages = messageParser(formatMessage);
        const avatarOrientation = integration === 'crossJoinNudgesJiraToJpd' ? 'horizontal' : 'vertical';
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b6Mjq.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndOptout,
                    onSubmit: submit,
                    avatarOrientation: avatarOrientation,
                    messages: cjnMessages,
                    featureVisitedCount: featureVisitedCount
                })
        });
    }, [
        formatMessage,
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
function $b205f495b5e2eb08$export$af59011edc35e856(timestampInMs) {
    const currentTime = Date.now();
    return ((currentTime - timestampInMs) / 1000).toFixed(3);
}
const $b205f495b5e2eb08$export$e748b6351ba5f204 = ({ users: users, userId: userId, sessionId: sessionId, featureVisitedCount: featureVisitedCount, startTimestamp: startTimestamp })=>{
    return {
        collaborators: users.length,
        userId: userId,
        sessionId: sessionId,
        featureVisitedCount: featureVisitedCount,
        eligibilityLatencySeconds: $b205f495b5e2eb08$export$af59011edc35e856(startTimestamp)
    };
};
const $b205f495b5e2eb08$export$53c813e9a54d378a = ({ entityId: entityId, isContextualBandit: isContextualBandit, ...args })=>{
    return {
        ...$b205f495b5e2eb08$export$e748b6351ba5f204(args),
        isContextualBandit: isContextualBandit,
        entityId: entityId
    };
};
const $b205f495b5e2eb08$export$882b0d75f031b08b = ({ firstName: firstName, companyName: companyName, generatedTitle: generatedTitle, generatedBody: generatedBody, ...rest })=>{
    function normalize(content) {
        return content.replaceAll(/[\W\d_]/g, '').toLowerCase();
    }
    function hasMatchingValue(value) {
        const r = new RegExp(normalize(value));
        return Boolean(value && (r.test(normalize(generatedTitle)) || r.test(normalize(generatedBody))));
    }
    return {
        ...$b205f495b5e2eb08$export$e748b6351ba5f204(rest),
        contentHasFirstName: hasMatchingValue(firstName),
        contentHasCompanyName: hasMatchingValue(companyName),
        isLLM: true
    };
};
const $b205f495b5e2eb08$export$7e2ad46880c00991 = ({ isContextualBandit: isContextualBandit, entityId: entityId, featureVisitedCount: featureVisitedCount })=>{
    return (formatMessage)=>{
        const dynamicMessages = (0, $5QB52.getDynamicMessages)(isContextualBandit, entityId) || (0, $6Jmsm.messages);
        const infoFlagTitle = isContextualBandit ? formatMessage((0, $6Jmsm.messages).title) : formatMessage((0, $6Jmsm.messages).urgencyTitle, {
            viewCount: featureVisitedCount
        });
        return {
            title: infoFlagTitle,
            description: formatMessage(dynamicMessages.description),
            joinButton: formatMessage(dynamicMessages.joinButton),
            remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $6Jmsm.messages).notInterestedButton)
        };
    };
};
const $b205f495b5e2eb08$export$77b0d0ed99f701d0 = (formatMessage)=>{
    return {
        title: formatMessage((0, $6Jmsm.messages).titleJpdNudge),
        description: formatMessage((0, $6Jmsm.messages).descriptionJpdNudge),
        joinButton: formatMessage((0, $6Jmsm.messages).getStartedButton),
        remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
        notInterestedButton: formatMessage((0, $6Jmsm.messages).doNotShowAgainButton)
    };
};
const $b205f495b5e2eb08$export$d9d7a49d4bfff37f = ({ title: title, description: description })=>{
    return (formatMessage)=>{
        return {
            title: title,
            description: description,
            joinButton: formatMessage((0, $6Jmsm.messages).joinButtonLlmGenerated),
            remindMeLaterButton: formatMessage((0, $6Jmsm.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $6Jmsm.messages).notInterestedButton)
        };
    };
};

});
parcelRegister("b6Mjq", function(module, exports) {

$parcel$export(module.exports, "RequestAccessPromptFlag", () => $06b71c6e3e5de02d$export$9b8813c3601640da);
/* flag-common.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7kJQm = parcelRequire("7kJQm");

var $3Wh6p = parcelRequire("3Wh6p");
var $bQP4O = parcelRequire("bQP4O");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $a9cht = parcelRequire("a9cht");

var $3SOCn = parcelRequire("3SOCn");

var $hUlSA = parcelRequire("hUlSA");
const $06b71c6e3e5de02d$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptoutAndDismiss: onOptoutAndDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, messages: messages, avatarOrientation: avatarOrientation, featureVisitedCount: featureVisitedCount, ...props })=>{
    const handleOnSubmit = (0, $eJOHy.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const customFlagFooterProps = (0, $eJOHy.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $3SOCn.noop)
                }
            ],
            linkComponent: ()=>{
                let secondETA = null;
                if (featureVisitedCount === 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: onSnoozeAndDismiss
                }, messages.remindMeLaterButton);
                else if (featureVisitedCount > 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: onOptoutAndDismiss
                }, messages.notInterestedButton);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                    xcss: $06b71c6e3e5de02d$var$linkButtonStyles,
                    onClick: handleOnSubmit
                }, messages.joinButton), !!secondETA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                    className: (0, $hcewu.default)([
                        "_1kt95qml _fntnutpp _eid3utpp"
                    ])
                }), secondETA);
            }
        }), [
        featureVisitedCount,
        handleOnSubmit,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $eJOHy.useMemo)(()=>{
        return users.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hUlSA.FlagCompatibleAvatarGroup), {
            alignment: avatarOrientation,
            maxAvatarCount: 2,
            tooltipPosition: "bottom",
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            size: "small",
            boundariesElement: "scrollParent"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        });
    }, [
        users,
        avatarOrientation
    ]);
    const FLAG_MESSAGE_TYPE = 'marketing';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: featureVisitedCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: messages.title,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
            className: (0, $hcewu.default)([
                "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0ccj1k _sudp1e54 _otyru2gc"
            ])
        }, messages.description)),
        icon: customIcon,
        messageType: FLAG_MESSAGE_TYPE,
        messageId: "cross-join-nudges.ui.request-access-prompt-flag.info-flag.request-access-prompt-flag"
    });
};
const $06b71c6e3e5de02d$var$linkButtonStyles = (0, $1DXK0.xcss)({
    maxWidth: '150',
    maxHeight: '3lh',
    overflow: 'hidden',
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: '0',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    cursor: 'pointer',
    padding: '0',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $06b71c6e3e5de02d$var$linkButtonSeparatorStyles = null;
const $06b71c6e3e5de02d$var$mainContentContainerStyles = null;

});
parcelRegister("3SOCn", function(module, exports) {

$parcel$export(module.exports, "noop", () => $4339374a2a8f4e6a$export$8793edee2d425525);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $4339374a2a8f4e6a$export$8793edee2d425525 = ()=>{};

});

parcelRegister("hUlSA", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $a339e7e80c202910$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $iwbbq = parcelRequire("iwbbq");

var $gqBnP = parcelRequire("gqBnP");

var $3SOCn = parcelRequire("3SOCn");
const $a339e7e80c202910$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $a339e7e80c202910$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $a339e7e80c202910$export$29beada2d5f93289 = ({ alignment: alignment, maxAvatarCount: maxAvatarCount, tooltipPosition: tooltipPosition, data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $eJOHy.useMemo)(()=>$a339e7e80c202910$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ // @ts-ignore
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, $3SOCn.noop),
        ...props
    });
    if (alignment === 'vertical') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a339e7e80c202910$var$VerticalAvatarGroupContainer, null, avatarGroup);
    return avatarGroup;
};
const $a339e7e80c202910$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount })=>{
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $a339e7e80c202910$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $a339e7e80c202910$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $a339e7e80c202910$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $a339e7e80c202910$var$OVERFLOW_USER_MARKER
    });
const $a339e7e80c202910$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iwbbq.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a339e7e80c202910$var$AvatarOverflowCountContainer, null, `+${Math.min(overflowCount, $a339e7e80c202910$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a339e7e80c202910$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhkm7j4 _syaz1fxt _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $a339e7e80c202910$var$VerticalAvatarGroupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ogvv1bp4 _3mc9idpf _1hlaidpf _1qu0x0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gqBnP", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ee9480fc7b69c2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $5DgXR = parcelRequire("5DgXR");


var $3Vuhz = parcelRequire("3Vuhz");

var $llBnk = parcelRequire("llBnk");

var $6YEko = parcelRequire("6YEko");

var $kJsb4 = parcelRequire("kJsb4");

var $k71qx = parcelRequire("k71qx");

var $8nCcr = parcelRequire("8nCcr");

var $1ld2P = parcelRequire("1ld2P");

var $e8NdE = parcelRequire("e8NdE");

var $8Au2G = parcelRequire("8Au2G");

var $8PScB = parcelRequire("8PScB");

var $9YB82 = parcelRequire("9YB82");

var $aeH98 = parcelRequire("aeH98");
const $36ee9480fc7b69c2$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $36ee9480fc7b69c2$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...props,
                    key: (0, $aeH98.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...props,
                    key: (0, $aeH98.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $36ee9480fc7b69c2$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $5DgXR.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eJOHy.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $llBnk.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eJOHy.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $3Vuhz.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $3Vuhz.default;
        (0, $4eDgu.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $9f42f4c07a71299e$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $9f42f4c07a71299e$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$36ee9480fc7b69c2$var$getOverrides(overrides).MoreIndicator.render((0, $8PScB.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e8NdE.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Au2G.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                            children: data.slice(max).map((avatar, index)=>$36ee9480fc7b69c2$var$getOverrides(overrides).AvatarGroupItem.render((0, $8nCcr.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $36ee9480fc7b69c2$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $9YB82.default) : (0, $1ld2P.default);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $36ee9480fc7b69c2$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $aeH98.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total)
        ]
    });
};
var $36ee9480fc7b69c2$export$2e2bcd8739ae039 = $36ee9480fc7b69c2$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $9f42f4c07a71299e$export$390330c10ff2b9a1 = 'ArrowUp';
const $9f42f4c07a71299e$export$a80636c6f41931fe = 'ArrowDown';
const $9f42f4c07a71299e$export$4af703091671bc = 'Home';
const $9f42f4c07a71299e$export$e2bc30913faa5db7 = 'End';
const $9f42f4c07a71299e$export$10f6869ed0a7d75b = 'Tab';
const $9f42f4c07a71299e$export$8152f929a25a0ff4 = 'Enter';
const $9f42f4c07a71299e$export$e51a3576c045c8d5 = 'Space';
const $9f42f4c07a71299e$export$2bb790b9008907b4 = 'Escape';

parcelRegister("8nCcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcb063c80fc7ca53$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $gyJTO = parcelRequire("gyJTO");

var $7saMl = parcelRequire("7saMl");
var $1PYwQ = parcelRequire("1PYwQ");
var $f58rc = parcelRequire("f58rc");

var $b65Ea = parcelRequire("b65Ea");
const $dcb063c80fc7ca53$var$AvatarGroupItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $b65Ea.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
        ref: (0, $gyJTO.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        ref: (0, $gyJTO.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1PYwQ.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dcb063c80fc7ca53$export$2e2bcd8739ae039 = $dcb063c80fc7ca53$var$AvatarGroupItem;

});
parcelRegister("b65Ea", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5c0c66be19727b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $e8NdE = parcelRequire("e8NdE");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $d5c0c66be19727b1$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eJOHy.useContext)((0, $e8NdE.FocusManagerContext));
    const itemRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $d5c0c66be19727b1$export$2e2bcd8739ae039 = $d5c0c66be19727b1$var$useRegisterItemWithFocusManager;

});
parcelRegister("e8NdE", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $d28720e9617ae246$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $d28720e9617ae246$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $3Vuhz = parcelRequire("3Vuhz");

var $a8nPO = parcelRequire("a8nPO");
const $d28720e9617ae246$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    menuItemRefs: [],
    registerRef: (0, $3Vuhz.default)
});
/**
 * Focus manager logic
 */ const $d28720e9617ae246$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eJOHy.useRef)([]);
    const registerRef = (0, $eJOHy.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eJOHy.useEffect)(()=>{
        (0, $4eDgu.bind)(window, {
            type: 'keydown',
            listener: (0, $a8nPO.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: (0, $a8nPO.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d28720e9617ae246$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $d28720e9617ae246$export$2e2bcd8739ae039 = $d28720e9617ae246$var$FocusManager;

});
parcelRegister("a8nPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88bdf832caa6c34$export$2e2bcd8739ae039);

const $f88bdf832caa6c34$var$actionMap = {
    [(0, $9f42f4c07a71299e$export$a80636c6f41931fe)]: 'next',
    [(0, $9f42f4c07a71299e$export$390330c10ff2b9a1)]: 'prev',
    [(0, $9f42f4c07a71299e$export$4af703091671bc)]: 'first',
    [(0, $9f42f4c07a71299e$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $f88bdf832caa6c34$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $f88bdf832caa6c34$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $f88bdf832caa6c34$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $f88bdf832caa6c34$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $f88bdf832caa6c34$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $f88bdf832caa6c34$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $f88bdf832caa6c34$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $f88bdf832caa6c34$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("1ld2P", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7ac3d16cd9447d$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $5e7ac3d16cd9447d$var$gutter = "var(--ds-space-negative-050, -4px)";
const $5e7ac3d16cd9447d$var$listStyles = null;
const $5e7ac3d16cd9447d$var$listItemStyles = null;
const $5e7ac3d16cd9447d$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $eJOHy.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                className: (0, $hcewu.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e7ac3d16cd9447d$export$2e2bcd8739ae039 = $5e7ac3d16cd9447d$var$Grid;

});

parcelRegister("8Au2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2b5b7b41d11fa6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $e8NdE = parcelRequire("e8NdE");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $1d2b5b7b41d11fa6$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eJOHy.useContext)((0, $e8NdE.FocusManagerContext));
    (0, $eJOHy.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUgeq.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $1d2b5b7b41d11fa6$export$2e2bcd8739ae039 = $1d2b5b7b41d11fa6$var$PopupAvatarGroup;

});

parcelRegister("8PScB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf80f821318091d$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $cdf80f821318091d$var$boxShadowCssVar = '--avatar-box-shadow';
const $cdf80f821318091d$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1q5u",
    active: "_bfhkfg4m _16qsqz53 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
const $cdf80f821318091d$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $cdf80f821318091d$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $cdf80f821318091d$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $cdf80f821318091d$var$MAX_DISPLAY_COUNT = 99;
const $cdf80f821318091d$var$MoreIndicator = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'circle', borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
borderColor = (0, $eGOwo.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $cdf80f821318091d$var$MAX_DISPLAY_COUNT ? $cdf80f821318091d$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$cdf80f821318091d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $hcewu.default)([
            $cdf80f821318091d$var$styles.root,
            $cdf80f821318091d$var$borderRadiusMap[size],
            appearance === 'circle' && $cdf80f821318091d$var$styles.circle,
            $cdf80f821318091d$var$widthHeightMap[size],
            $cdf80f821318091d$var$fontMap[size],
            isActive && $cdf80f821318091d$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$cdf80f821318091d$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cdf80f821318091d$export$2e2bcd8739ae039 = $cdf80f821318091d$var$MoreIndicator;

});

parcelRegister("9YB82", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3bb26966f739c04$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $d3bb26966f739c04$var$listStyles = null;
const $d3bb26966f739c04$var$listItemStyles = null;
const $d3bb26966f739c04$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $eJOHy.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                className: (0, $hcewu.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3bb26966f739c04$export$2e2bcd8739ae039 = $d3bb26966f739c04$var$Stack;

});

parcelRegister("aeH98", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $871dcdf2e893338b$export$b067756944994c79);
const $871dcdf2e893338b$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});





parcelRegister("5Ilbg", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessSuccessFlag", () => $d17f1500a13d668e$export$184b02cbba392fc0);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $csiXm = parcelRequire("csiXm");

var $b4yA6 = parcelRequire("b4yA6");
const $d17f1500a13d668e$export$184b02cbba392fc0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)(()=>{
        const id = `success-${(0, $csiXm.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d17f1500a13d668e$export$567128fc1024c9cf, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $d17f1500a13d668e$export$567128fc1024c9cf = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.SuccessFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $b4yA6.messages).title),
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $b4yA6.messages).description))
    });
};

});
parcelRegister("b4yA6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a8ff2ae59932fa6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1a8ff2ae59932fa6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-success-flag.title",
        "defaultMessage": "A request was sent to your admins"
    },
    description: {
        "id": "cross-join-nudges.request-access-success-flag.description",
        "defaultMessage": "You'll receive an email once they've reviewed it."
    }
});

});


parcelRegister("97hJ3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $045a6f98130d6b69$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $gYnSx = parcelRequire("gYnSx");
const $045a6f98130d6b69$export$e926676385687eaf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        onError: (_, error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'cross-join-nudges-your-work-error-boundary'
                },
                error: error
            });
        }
    }, children);

});

parcelRegister("47sip", function(module, exports) {

$parcel$export(module.exports, "CrossJoinNudgeYourWorkCard", () => $aff65f1bed34d9bb$export$7ac60ccf67d54f65);

var $eJOHy = parcelRequire("eJOHy");

var $gqBnP = parcelRequire("gqBnP");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $hSeHB = parcelRequire("hSeHB");

var $fOIfK = parcelRequire("fOIfK");

var $1k4qz = parcelRequire("1k4qz");

var $f8URv = parcelRequire("f8URv");

var $j3L3Z = parcelRequire("j3L3Z");

var $2aW16 = parcelRequire("2aW16");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $7yVAf = parcelRequire("7yVAf");
const $aff65f1bed34d9bb$var$Actions = ({ onSubmit: onSubmit, onSnooze: onSnooze, onOptOut: onOptOut, collaborators: collaborators })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $7yVAf.messages).joinYourTeam,
        values: {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name.split(' ')[0]
        }
    })), onSnooze && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onSnooze
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $7yVAf.messages).remindMeLater)), onOptOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onOptOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $7yVAf.messages).notInterested)));
const $aff65f1bed34d9bb$var$Avatars = ({ collaborators: collaborators })=>{
    const data = [
        (0, (/*@__PURE__*/$parcel$interopDefault($j3L3Z))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fOIfK))),
        (0, (/*@__PURE__*/$parcel$interopDefault($1k4qz))),
        (0, (/*@__PURE__*/$parcel$interopDefault($f8URv)))
    ].map((src)=>({
            name: '',
            src: src
        }));
    for (const [i, user] of collaborators.entries())data[i] = {
        name: user.name,
        src: user.avatar
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aff65f1bed34d9bb$var$AvatarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        appearance: "stack",
        data: data,
        maxCount: 4,
        size: "large",
        borderColor: "white",
        testId: "cross-join-nudges.ui.your-work-widget.ui"
    }));
};
const $aff65f1bed34d9bb$export$7ac60ccf67d54f65 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onRender: onRender, collaborators: collaborators, onDismiss: onDismiss, ...actionsProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    onRender();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aff65f1bed34d9bb$var$Wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aff65f1bed34d9bb$var$Avatars, {
        collaborators: collaborators
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hSeHB.PromotionalCard), {
        header: formatMessage((0, $7yVAf.messages).header, {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2aW16))),
        imageAltText: formatMessage((0, $7yVAf.messages).imageAltText),
        description: formatMessage((0, $7yVAf.messages).description),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aff65f1bed34d9bb$var$Actions, {
            ...actionsProps,
            collaborators: collaborators
        }),
        reason: formatMessage((0, $7yVAf.messages).tooltip),
        analyticsSource: "cross-join-nudges-your-work",
        onDismiss: onDismiss
    }));
});
const $aff65f1bed34d9bb$var$AvatarWrapper = (0, $1DXK0.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: '144px',
    top: '35px'
});
const $aff65f1bed34d9bb$var$Wrapper = (0, $1DXK0.xcss)({
    display: 'inline-block',
    position: 'relative'
});

});
parcelRegister("hSeHB", function(module, exports) {

$parcel$export(module.exports, "PromotionalCard", () => $0557b7db6a98b3d0$export$418393e556a23457);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cA0Y2 = parcelRequire("cA0Y2");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $7MiYh = parcelRequire("7MiYh");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");

var $chHcg = parcelRequire("chHcg");
const $0557b7db6a98b3d0$export$418393e556a23457 = ({ imageUrl: imageUrl, imageAltText: imageAltText, header: header, description: description, primaryAction: primaryAction, reason: reason, analyticsSource: analyticsSource, isDismissLoading: isDismissLoading, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$cae2783c9279926),
        sourceName: analyticsSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$Wrapper, null, onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        appearance: "subtle",
        spacing: "none",
        isLoading: isDismissLoading,
        "aria-label": formatMessage((0, $chHcg.default).dismiss),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-warning-inverse, #172B4D)"
        }),
        onClick: (e, analyticsEvent)=>{
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, `${analyticsSource}Dismiss`);
            onDismiss();
        }
    })), imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$ImageContainer, {
        imageUrl: imageUrl
    }, imageAltText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "img",
        "aria-label": imageAltText
    }) : null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium",
        as: "h2"
    }, header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$Description, null, description), primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: reason,
        onShow: (analyticsEvent)=>(0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'promotionalCardInfo')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0557b7db6a98b3d0$var$FooterContent, {
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7MiYh))), {
        LEGACY_size: "small",
        label: ""
    }), formatMessage((0, $chHcg.default).footerContent))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _bfhkvuon _16qs9g9j _1bsb1gwv _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$Header = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _c71lckbl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$ImageContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { imageUrl: imageUrl, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ntxwly": (0, $awdRS.default)(`url(${__cmplp.imageUrl})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1lrw1dfr _4t3ibv7e _1bsb1osq _1itklex0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _19pkutpp _otyrutpp _syaz1fxt _c71l1wqb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$Footer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _1e0c1txw _1bah1h6o _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$FooterContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _11c81o8v _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0557b7db6a98b3d0$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iv47k _1xi21ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6J9k6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e5e2d758ad941bc$var$_react = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4e5e2d758ad941bc$var$_cross = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $4e5e2d758ad941bc$var$_cross2 = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("laG04")));
function $4e5e2d758ad941bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e5e2d758ad941bc$var$CrossIcon = (props)=>/*#__PURE__*/ $4e5e2d758ad941bc$var$_react.default.createElement($4e5e2d758ad941bc$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $4e5e2d758ad941bc$var$_cross2.default
    }, props));
$4e5e2d758ad941bc$var$CrossIcon.Name = 'CrossIconMigration';
var $4e5e2d758ad941bc$var$_default = module.exports.default = $4e5e2d758ad941bc$var$CrossIcon;

});

parcelRegister("7MiYh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56ceccaeae6b6ab573cba52e86f8798f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a9bbb61075558f7$var$_react = $5a9bbb61075558f7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5a9bbb61075558f7$var$_information = $5a9bbb61075558f7$var$_interopRequireDefault((parcelRequire("6eUFQ")));

var $5a9bbb61075558f7$var$_panel = $5a9bbb61075558f7$var$_interopRequireDefault((parcelRequire("1Sm4w")));
function $5a9bbb61075558f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a9bbb61075558f7$var$InformationIcon = (props)=>/*#__PURE__*/ $5a9bbb61075558f7$var$_react.default.createElement($5a9bbb61075558f7$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $5a9bbb61075558f7$var$_panel.default
    }, props));
$5a9bbb61075558f7$var$InformationIcon.Name = 'InformationIconMigration';
var $5a9bbb61075558f7$var$_default = module.exports.default = $5a9bbb61075558f7$var$InformationIcon;

});
parcelRegister("1Sm4w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15dbf4a3ad51a12e$var$_react = $15dbf4a3ad51a12e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $15dbf4a3ad51a12e$var$_information = $15dbf4a3ad51a12e$var$_interopRequireDefault((parcelRequire("6eUFQ")));
function $15dbf4a3ad51a12e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $15dbf4a3ad51a12e$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $15dbf4a3ad51a12e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $15dbf4a3ad51a12e$var$_information.default
    }));
$15dbf4a3ad51a12e$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $15dbf4a3ad51a12e$var$_default = module.exports.default = $15dbf4a3ad51a12e$var$EditorPanelIcon;

});


// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("chHcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $93399a9d1bfa9fa3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $93399a9d1bfa9fa3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    dismiss: {
        "id": "home-common-ui.promotional-card.dismiss",
        "defaultMessage": "Close"
    },
    footerContent: {
        "id": "home-common-ui.promotional-card.footer-content",
        "defaultMessage": "Why am I seeing this?"
    }
});

});


parcelRegister("fOIfK", function(module, exports) {
module.exports = new URL("Angie.ce60f296.svg", import.meta.url).toString();

});

parcelRegister("1k4qz", function(module, exports) {
module.exports = new URL("Ed.d7b4103d.svg", import.meta.url).toString();

});

parcelRegister("f8URv", function(module, exports) {
module.exports = new URL("More.e627945d.svg", import.meta.url).toString();

});

parcelRegister("j3L3Z", function(module, exports) {
module.exports = new URL("Norah.1b131c52.svg", import.meta.url).toString();

});

parcelRegister("2aW16", function(module, exports) {
module.exports = new URL("generic-background.3268bb58.svg", import.meta.url).toString();

});

parcelRegister("7yVAf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b23710cc30887c6e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b23710cc30887c6e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    header: {
        "id": "cross-join-nudges.your-work.header",
        "defaultMessage": "{collaborators, plural, =0 {Your team is using Confluence} one {{collaborator} is using Confluence} other {{collaborator} and others are using Confluence}}"
    },
    description: {
        "id": "cross-join-nudges.your-work.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    joinYourTeam: {
        "id": "cross-join-nudges.your-work.join-your-team",
        "defaultMessage": "{collaborators, plural, one {Join {collaborator}} other {Join your team}}"
    },
    remindMeLater: {
        "id": "cross-join-nudges.your-work.remind-me-later",
        "defaultMessage": "Remind me later"
    },
    notInterested: {
        "id": "cross-join-nudges.your-work.not-interested",
        "defaultMessage": "Not interested"
    },
    tooltip: {
        "id": "cross-join-nudges.your-work.tooltip",
        "defaultMessage": "You're seeing this suggestion because you may want to use Confluence to work with the same people you work with in Jira. Your Jira teammates already use Confluence."
    },
    imageAltText: {
        "id": "cross-join-nudges.your-work.image-alt-text",
        "defaultMessage": "Your team collaborating on a document in Confluence"
    }
});

});



parcelRegister("8GjHG", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherIntegrationEntrypoint", () => $b75db2fe04fc9a57$export$7b5dbeab5e41f2a4);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b75db2fe04fc9a57$export$7b5dbeab5e41f2a4 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fvwy0")), {
        moduleId: "9be44a41",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>({
            extraProps: params
        })
});

});
parcelRegister("fvwy0", function(module, exports) {

let $b4a2ff801c93c758$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b4a2ff801c93c758$var$load("haJB1").then(()=>parcelRequire('dCJZe'));

});


parcelRegister("eMKWj", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderButton", () => $bd851b7a65927949$export$46b00316abad4d7b);

var $eJOHy = parcelRequire("eJOHy");

var $lT9x0 = parcelRequire("lT9x0");

var $guChT = parcelRequire("guChT");

var $7aCti = parcelRequire("7aCti");

var $axnxR = parcelRequire("axnxR");

var $bJscI = parcelRequire("bJscI");
const $bd851b7a65927949$export$46b00316abad4d7b = /*#__PURE__*/ (0, $eJOHy.forwardRef)($bd851b7a65927949$var$AppSwitcherPBWithRef);
function $bd851b7a65927949$var$AppSwitcherPBWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aCti.AppSwitcher), {
        label: (0, $axnxR.SwitchToTooltipText),
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowser, {
        ref: ref,
        onOpen: onOpen,
        onMouseEnter: onMouseEnter
    });
}
const $bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowser = /*#__PURE__*/ (0, $eJOHy.forwardRef)($bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowserWithRef);
function $bd851b7a65927949$var$AppSwitcherPlaceholderButtonForBrowserWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd851b7a65927949$var$AppSwitcherLightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aCti.AppSwitcher), {
        ref: ref,
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $axnxR.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    }));
}
const $bd851b7a65927949$var$AppSwitcherLightWrapper = (0, $bJscI.componentWithFG)('app_switcher_spotlight_gate', $bd851b7a65927949$var$SpotLightWrapper, (0, $eJOHy.Fragment));
function $bd851b7a65927949$var$SpotLightWrapper(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "app-switcher-spotlight"
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
        engagementId: "app-switcher-spotlight"
    }));
}

});
parcelRegister("7aCti", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $a0d5cee1781ba055$export$9923361bd43fa030);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5eJzr = parcelRequire("5eJzr");

var $6kf2c = parcelRequire("6kf2c");
const $a0d5cee1781ba055$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $a0d5cee1781ba055$export$9923361bd43fa030 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kf2c.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5eJzr))),
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $a0d5cee1781ba055$var$toggleButtonTooltipOptions,
        isSelected: isSelected
    }));

});
parcelRegister("5eJzr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d019beb364cfa1f$var$_react = $3d019beb364cfa1f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3d019beb364cfa1f$var$_baseNew = $3d019beb364cfa1f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3d019beb364cfa1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d019beb364cfa1f$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $3d019beb364cfa1f$var$_react.default.createElement($3d019beb364cfa1f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$3d019beb364cfa1f$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $3d019beb364cfa1f$var$_default = module.exports.default = $3d019beb364cfa1f$var$AppSwitcherIcon;

});


parcelRegister("axnxR", function(module, exports) {

$parcel$export(module.exports, "SwitchToTooltipText", () => $1bfee3be9faf324e$export$c5ef4d14b7e18cbd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4uNLM = parcelRequire("4uNLM");

var $lK21m = parcelRequire("lK21m");
const $1bfee3be9faf324e$export$c5ef4d14b7e18cbd = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4uNLM.default), {
    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $lK21m.default).switchSitesOrAppsTooltip
    })
});

});
parcelRegister("4uNLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a27d5cbcea41441$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $9pMuS = parcelRequire("9pMuS");


var $gdqa5 = parcelRequire("gdqa5");

var $ftN6c = parcelRequire("ftN6c");






























function $4a27d5cbcea41441$var$fetchLanguageFile(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("g6wSR"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("abGg6"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("k56eo"));
        case 'en-GB':
            return (parcelRequire("8o2Le"));
        case 'en-ZZ':
            return (parcelRequire("7Iomk"));
        case 'en-US':
        case 'en':
            return (parcelRequire("kFyh5"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("cFWoR"));
        case 'et':
            return (parcelRequire("2xEiS"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("ayhXS"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("jrFv3"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("hYV6V"));
        case 'is':
            return (parcelRequire("f56bf"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("lTb3F"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("j9tIV"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("cjPPV"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("hGGjy"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("aG6bz"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("jzuVP"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("89gSV"));
        case 'pt-PT':
            return (parcelRequire("7V8PU"));
        case 'ro':
            return (parcelRequire("l9BTl"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("4kNuF"));
        case 'sk':
            return (parcelRequire("cQfZ4"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("6achp"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("7dzGx"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("39w4b"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("5up2X"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("8duYC"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("aWilV"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("i8l6a"));
    }
    throw Error(`Unable to find translation for locale ${locale}`);
}
const $4a27d5cbcea41441$var$SwitcherIntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    // Intl.Locale doesn't like underscores
    const [isLocaleLoaded, setIsLocaleLoaded] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [messages, setMessages] = (0, $eJOHy.useState)({});
    (0, $eJOHy.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const intlLocale = new Intl.Locale(locale.replace('_', '-'));
            try {
                const module = await $4a27d5cbcea41441$var$fetchLanguageFile(intlLocale.toString());
                const newMessages = module.default || module;
                setMessages(newMessages);
                setIsLocaleLoaded(true);
            } catch (e) {
                // fail to download message and do nothing because UI will use default language (English) to render
                setIsLocaleLoaded(true);
                createAnalyticsEvent({
                    eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                    action: 'not_loaded',
                    actionSubject: 'i18n',
                    attributes: {
                        country: intlLocale.region,
                        language: intlLocale.language
                    }
                }).fire((0, $gdqa5.NAVIGATION_CHANNEL));
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        createAnalyticsEvent
    ]);
    // delay loading until we have attempted to load the locale data otherwise we can flick from English to the user's language
    if (!isLocaleLoaded) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9pMuS.default), {});
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        children: children
    }, locale);
};
var $4a27d5cbcea41441$export$2e2bcd8739ae039 = $4a27d5cbcea41441$var$SwitcherIntlProvider;

});
parcelRegister("9pMuS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc245b286ee913d8$export$2e2bcd8739ae039);
/* skeleton-with-orgs.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $gZSfe = parcelRequire("gZSfe");
var $kI28I = parcelRequire("kI28I");

var $cy9FC = parcelRequire("cy9FC");
const $cc245b286ee913d8$var$iconSkeleton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        borderRadius: "var(--ds-border-radius-200, 8px)"
    }
});
const $cc245b286ee913d8$var$orgs = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
    "aria-hidden": "true",
    style: {
        display: 'flex',
        paddingInline: "var(--ds-space-150, 12px)",
        paddingBlock: "var(--ds-space-100, 8px)",
        alignItems: 'center'
    },
    children: $cc245b286ee913d8$var$iconSkeleton
});
var $cc245b286ee913d8$export$2e2bcd8739ae039 = ()=>{
    (0, $kI28I.useExperienceRenderAndMountMark)((0, $gZSfe.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        style: {
            display: 'flex',
            flexDirection: 'row',
            gap: "var(--ds-space-100, 8px)",
            height: '80vh',
            position: 'relative'
        },
        testId: "skeleton-with-orgs",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                "aria-hidden": "true",
                style: {
                    width: '56px',
                    height: '100%',
                    paddingTop: "var(--ds-space-300, 24px)",
                    borderRight: `2px solid ${"var(--ds-skeleton, #091E420F)"}`,
                    alignItems: 'center'
                },
                children: [
                    $cc245b286ee913d8$var$orgs,
                    $cc245b286ee913d8$var$orgs,
                    $cc245b286ee913d8$var$orgs
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cy9FC.default), {})
        ]
    });
};

});
parcelRegister("gZSfe", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $aba7ab916f143273$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $aba7ab916f143273$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $aba7ab916f143273$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $aba7ab916f143273$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $aba7ab916f143273$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $aba7ab916f143273$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $aba7ab916f143273$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $aba7ab916f143273$export$86919b84f9a64054);

var $2lxLk = parcelRequire("2lxLk");

var $1LsJB = parcelRequire("1LsJB");
var $aba7ab916f143273$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    return Experience;
}({});
const $aba7ab916f143273$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $aba7ab916f143273$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $aba7ab916f143273$var$allNonTestExperienceMarks = Object.values($aba7ab916f143273$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $aba7ab916f143273$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $aba7ab916f143273$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $aba7ab916f143273$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $aba7ab916f143273$var$allNonTestExperienceMarks
};
const $aba7ab916f143273$export$805ed806e0769ee4 = (0, $1LsJB.invertRecordOfArrays)($aba7ab916f143273$export$755e75afbd377bc4);
var $aba7ab916f143273$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $aba7ab916f143273$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $aba7ab916f143273$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("1LsJB", function(module, exports) {

$parcel$export(module.exports, "invertRecordOfArrays", () => $e34d120f6bad399e$export$c371a74fe5222b3);
function $e34d120f6bad399e$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("kI28I", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $a5f69cfd6a6b9807$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $a5f69cfd6a6b9807$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $1taFi = parcelRequire("1taFi");

var $eJOHy = parcelRequire("eJOHy");

var $313yD = parcelRequire("313yD");
function $a5f69cfd6a6b9807$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $1taFi.useExperienceTracker)();
    (0, $313yD.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $a5f69cfd6a6b9807$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $1taFi.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $a5f69cfd6a6b9807$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $1taFi.useExperienceTracker)();
    (0, $313yD.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("1taFi", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $193679940d67a515$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $193679940d67a515$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $193679940d67a515$export$f88dde183f4d31cb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $193679940d67a515$var$noop = ()=>{};
const $193679940d67a515$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    start: $193679940d67a515$var$noop,
    success: $193679940d67a515$var$noop,
    failure: $193679940d67a515$var$noop,
    failureAll: $193679940d67a515$var$noop,
    abort: $193679940d67a515$var$noop,
    abortAll: $193679940d67a515$var$noop,
    markStart: $193679940d67a515$var$noop,
    markEnd: $193679940d67a515$var$noop
});
const $193679940d67a515$export$cdefb2a8b53f879f = ()=>(0, $eJOHy.useContext)($193679940d67a515$export$3f3eebb4b8116461);
const $193679940d67a515$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $193679940d67a515$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});

parcelRegister("313yD", function(module, exports) {

$parcel$export(module.exports, "useSingleton", () => $45e85f7dae640bb9$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $45e85f7dae640bb9$export$ad4f8d0eee7a0e24);

var $eJOHy = parcelRequire("eJOHy");
function $45e85f7dae640bb9$export$abf4268d2dd55708(builder) {
    const ref = (0, $eJOHy.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $45e85f7dae640bb9$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $eJOHy.useRef)(false);
    const result = (0, $eJOHy.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});


parcelRegister("cy9FC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e641ec313a41eb45$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $gZSfe = parcelRequire("gZSfe");
var $kI28I = parcelRequire("kI28I");

var $lRq8t = parcelRequire("lRq8t");

var $agwRm = parcelRequire("agwRm");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $e641ec313a41eb45$var$iconSkeleton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        borderRadius: "var(--ds-border-radius-200, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $e641ec313a41eb45$var$lineSkeleton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        borderRadius: "var(--ds-border-radius, 4px)"
    }
});
var $e641ec313a41eb45$export$2e2bcd8739ae039 = ()=>{
    (0, $kI28I.useExperienceRenderAndMountMark)((0, $gZSfe.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const items = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        },
        children: [
            $e641ec313a41eb45$var$iconSkeleton,
            $e641ec313a41eb45$var$lineSkeleton
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        as: "section",
        style: {
            width: '343px'
        },
        role: "alert",
        "aria-label": formatMessage((0, $agwRm.default).skeletonLoaderAriaLabel),
        testId: "skeleton",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                "aria-hidden": "true",
                style: {
                    paddingInline: "var(--ds-space-200, 16px)",
                    paddingTop: "var(--ds-space-300, 24px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                },
                children: $e641ec313a41eb45$var$lineSkeleton
            }),
            items,
            items,
            items
        ]
    });
};

});
parcelRegister("agwRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4e2ce04eb2286b7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e4e2ce04eb2286b7$var$messages = (0, $7qGN1.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primative'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    }
});
var $e4e2ce04eb2286b7$export$2e2bcd8739ae039 = $e4e2ce04eb2286b7$var$messages;

});



// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

parcelRegister("gdqa5", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $d21a4958c492cfbf$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $d21a4958c492cfbf$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $d21a4958c492cfbf$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $d21a4958c492cfbf$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $d21a4958c492cfbf$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $d21a4958c492cfbf$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $d21a4958c492cfbf$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $d21a4958c492cfbf$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $d21a4958c492cfbf$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $d21a4958c492cfbf$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $d21a4958c492cfbf$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $d21a4958c492cfbf$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_NAME_EXPAND_PANEL", () => $d21a4958c492cfbf$export$53f2256589c0fa08);
$parcel$export(module.exports, "SWITCHER_CURRENT_ORG", () => $d21a4958c492cfbf$export$44c7ac3fdc1d62b8);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $d21a4958c492cfbf$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $d21a4958c492cfbf$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $d21a4958c492cfbf$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $d21a4958c492cfbf$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $d21a4958c492cfbf$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $d21a4958c492cfbf$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $d21a4958c492cfbf$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $d21a4958c492cfbf$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $d21a4958c492cfbf$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getJoinableSitesRenderTracker", () => $d21a4958c492cfbf$export$e823e937102b322b);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $d21a4958c492cfbf$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $d21a4958c492cfbf$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("4J0ad")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("eUaD0")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $d6f34b7bd34f6138$export$12346a674644c156);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $d6f34b7bd34f6138$export$a1562d08625f5d7e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");

var $5fWw9 = parcelRequire("5fWw9");
var $4J0ad = parcelRequire("4J0ad");


var $3ZEcX = parcelRequire("3ZEcX");

var $4Az9V = parcelRequire("4Az9V");

var $hp1OS = parcelRequire("hp1OS");
const $d21a4958c492cfbf$export$515664faa1398f37 = 'navigation';
const $d21a4958c492cfbf$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $d21a4958c492cfbf$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $d21a4958c492cfbf$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $d21a4958c492cfbf$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $d21a4958c492cfbf$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $d21a4958c492cfbf$export$2b570fc112cbca = 'atlassianSwitcher';
const $d21a4958c492cfbf$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $d21a4958c492cfbf$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $d21a4958c492cfbf$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $d21a4958c492cfbf$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $d21a4958c492cfbf$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $d21a4958c492cfbf$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $d21a4958c492cfbf$export$44c7ac3fdc1d62b8 = 'atlassianSwitcherCurrentOrg';
const $d21a4958c492cfbf$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $d21a4958c492cfbf$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $d21a4958c492cfbf$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $d21a4958c492cfbf$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $d21a4958c492cfbf$var$RENDERED_ACTION = 'rendered';
const $d21a4958c492cfbf$var$NOT_RENDERED_ACTION = 'not_rendered';
const $d21a4958c492cfbf$var$VIEWED_ACTION = 'viewed';
const $d21a4958c492cfbf$export$884b1a4c7ac9dd14 = (0, $5fWw9.default)($d21a4958c492cfbf$export$515664faa1398f37);
const $d21a4958c492cfbf$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $d21a4958c492cfbf$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.NavigationAnalyticsContext), {
                data: mapPropsToContext(props),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                    ...props
                })
            });
    };
};
const $d21a4958c492cfbf$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $d21a4958c492cfbf$export$e09ad93c2b74b853 = (0, $4J0ad.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            action: $d21a4958c492cfbf$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$d21a4958c492cfbf$var$isValidDuration(duration) && {
                    bucket: (0, $hp1OS.getMetricBucket)(duration, (0, $hp1OS.RenderTrackerBuckets))
                }
            }
        }).fire($d21a4958c492cfbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $d21a4958c492cfbf$export$95b1f1a72cad0dcb = (0, $4J0ad.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            action: $d21a4958c492cfbf$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($d21a4958c492cfbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $d21a4958c492cfbf$export$b3fd6624b6a6d057 = (0, $4J0ad.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            action: $d21a4958c492cfbf$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($d21a4958c492cfbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $d21a4958c492cfbf$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $d21a4958c492cfbf$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $d21a4958c492cfbf$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $3ZEcX.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $d21a4958c492cfbf$var$renderTracker({
        subject: $d21a4958c492cfbf$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $d21a4958c492cfbf$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $3ZEcX.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $4Az9V.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $d21a4958c492cfbf$var$renderTrackerWithReason({
        subject: $d21a4958c492cfbf$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $d21a4958c492cfbf$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$d21a4958c492cfbf$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("3ZEcX", function(module, exports) {

$parcel$export(module.exports, "Status", () => $860a69f0005a2ce3$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $860a69f0005a2ce3$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $860a69f0005a2ce3$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "hasLoaded", () => $860a69f0005a2ce3$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $860a69f0005a2ce3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gdqa5 = parcelRequire("gdqa5");

var $4J0ad = parcelRequire("4J0ad");

var $ll8p3 = parcelRequire("ll8p3");

var $iHrhr = parcelRequire("iHrhr");

var $1taFi = parcelRequire("1taFi");
const $860a69f0005a2ce3$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $860a69f0005a2ce3$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $860a69f0005a2ce3$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $860a69f0005a2ce3$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $860a69f0005a2ce3$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $860a69f0005a2ce3$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $860a69f0005a2ce3$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $860a69f0005a2ce3$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static{
            this.displayName = `DataProvider(${name})`;
        }
        componentWillUnmount() {
            /**
			 * Promise resolved after component is unmounted to be ignored
			 */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $iHrhr.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $ll8p3.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
			 * Do not transition from "complete" state to "error"
			 */ if (this.acceptResults && !$860a69f0005a2ce3$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $ll8p3.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                    actionSubject: $860a69f0005a2ce3$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $gdqa5.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $4J0ad.default)()((0, $1taFi.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)(InnerComponent, {
            params: params,
            children: children
        });
    };
    return OuterComponent;
}

});
parcelRegister("ll8p3", function(module, exports) {

$parcel$export(module.exports, "errorToReason", () => $3cdee95c99b74c5f$export$a3e288208721751b);
function $3cdee95c99b74c5f$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("iHrhr", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $4e5d3940dbbde5e0$export$1d94629c94e7a17f);
const $4e5d3940dbbde5e0$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $4e5d3940dbbde5e0$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $4e5d3940dbbde5e0$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});


parcelRegister("4Az9V", function(module, exports) {

$parcel$export(module.exports, "UserSiteDataErrorReason", () => $e31798a0cb2ba326$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $e31798a0cb2ba326$export$c460344055e97b1);
var $e31798a0cb2ba326$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $e31798a0cb2ba326$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("hp1OS", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerBuckets", () => $a9b6af5a83f41588$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $a9b6af5a83f41588$export$b59492d26971ae92);
const $a9b6af5a83f41588$var$INFINITY = '+Inf';
const $a9b6af5a83f41588$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $a9b6af5a83f41588$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $a9b6af5a83f41588$var$INFINITY) : null;
};

});


parcelRegister("g6wSR", function(module, exports) {

let $bb96b6ef866401c4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bb96b6ef866401c4$var$load("dbGVv").then(()=>parcelRequire('bwYWn'));

});

parcelRegister("abGg6", function(module, exports) {

let $76abb62bf9d1c239$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $76abb62bf9d1c239$var$load("1eEkR").then(()=>parcelRequire('fpuot'));

});

parcelRegister("k56eo", function(module, exports) {

let $e9e91baacf604bc4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e9e91baacf604bc4$var$load("8NZXA").then(()=>parcelRequire('3u7xR'));

});

parcelRegister("8o2Le", function(module, exports) {

let $61b2b4d6e8d88385$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61b2b4d6e8d88385$var$load("fX3JH").then(()=>parcelRequire('jBI3h'));

});

parcelRegister("7Iomk", function(module, exports) {

let $59df89b0984ad580$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $59df89b0984ad580$var$load("3ky86").then(()=>parcelRequire('kTbfK'));

});

parcelRegister("kFyh5", function(module, exports) {

let $f0c23933277cc4af$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f0c23933277cc4af$var$load("8lFsj").then(()=>parcelRequire('1vlnd'));

});

parcelRegister("cFWoR", function(module, exports) {

let $93a69d6390cba351$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93a69d6390cba351$var$load("fXqh3").then(()=>parcelRequire('eQ5x7'));

});

parcelRegister("2xEiS", function(module, exports) {

let $1d9ded44f3dbdc47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1d9ded44f3dbdc47$var$load("gd5li").then(()=>parcelRequire('hPTxc'));

});

parcelRegister("ayhXS", function(module, exports) {

let $7aeb03c8f2d8779d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7aeb03c8f2d8779d$var$load("1fEC8").then(()=>parcelRequire('l9FKp'));

});

parcelRegister("jrFv3", function(module, exports) {

let $e280baf3e90e080f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e280baf3e90e080f$var$load("ewJlC").then(()=>parcelRequire('2kWm6'));

});

parcelRegister("hYV6V", function(module, exports) {

let $d1745741d7d4aff8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d1745741d7d4aff8$var$load("hfJvO").then(()=>parcelRequire('gvs5F'));

});

parcelRegister("f56bf", function(module, exports) {

let $afac1df8e41f2402$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $afac1df8e41f2402$var$load("8aF6Y").then(()=>parcelRequire('k2vLq'));

});

parcelRegister("lTb3F", function(module, exports) {

let $fef74feebf40536a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fef74feebf40536a$var$load("2cfNn").then(()=>parcelRequire('13EZY'));

});

parcelRegister("j9tIV", function(module, exports) {

let $df15ea191d808361$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df15ea191d808361$var$load("iCAVc").then(()=>parcelRequire('lbmdH'));

});

parcelRegister("cjPPV", function(module, exports) {

let $8f7f780b04b2c725$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8f7f780b04b2c725$var$load("42qE5").then(()=>parcelRequire('4leZi'));

});

parcelRegister("hGGjy", function(module, exports) {

let $ce072ea68013b255$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ce072ea68013b255$var$load("fru0c").then(()=>parcelRequire('eFD7t'));

});

parcelRegister("aG6bz", function(module, exports) {

let $7c629ffccd60b543$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7c629ffccd60b543$var$load("4bt3q").then(()=>parcelRequire('7jeSP'));

});

parcelRegister("jzuVP", function(module, exports) {

let $e3f9479ce75f2949$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e3f9479ce75f2949$var$load("jYEAu").then(()=>parcelRequire('dej0b'));

});

parcelRegister("89gSV", function(module, exports) {

let $5eec42f8828f340e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5eec42f8828f340e$var$load("lTiX1").then(()=>parcelRequire('3LIgV'));

});

parcelRegister("7V8PU", function(module, exports) {

let $5c44b5f2b850056c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5c44b5f2b850056c$var$load("dYKS0").then(()=>parcelRequire('9u7hm'));

});

parcelRegister("l9BTl", function(module, exports) {

let $f667d4b6eb24810c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f667d4b6eb24810c$var$load("j8LyV").then(()=>parcelRequire('5LTxU'));

});

parcelRegister("4kNuF", function(module, exports) {

let $327f6c1ad1763570$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $327f6c1ad1763570$var$load("cFtyz").then(()=>parcelRequire('l8BRw'));

});

parcelRegister("cQfZ4", function(module, exports) {

let $9596bd73e0cd6557$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9596bd73e0cd6557$var$load("fRxDU").then(()=>parcelRequire('1qbF0'));

});

parcelRegister("6achp", function(module, exports) {

let $47cd33c08d3c6465$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $47cd33c08d3c6465$var$load("ckqbP").then(()=>parcelRequire('bhz32'));

});

parcelRegister("7dzGx", function(module, exports) {

let $015b2f300eb37386$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $015b2f300eb37386$var$load("doHJv").then(()=>parcelRequire('bNJtO'));

});

parcelRegister("39w4b", function(module, exports) {

let $24bb1617046ae6fd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $24bb1617046ae6fd$var$load("hRhkr").then(()=>parcelRequire('89m2r'));

});

parcelRegister("5up2X", function(module, exports) {

let $3ff32edb30d6b876$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3ff32edb30d6b876$var$load("bvu0i").then(()=>parcelRequire('fzQQz'));

});

parcelRegister("8duYC", function(module, exports) {

let $5fb790f0903651e5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5fb790f0903651e5$var$load("gt5IT").then(()=>parcelRequire('gwfIx'));

});

parcelRegister("aWilV", function(module, exports) {

let $7f6d8e9dd9641fcc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f6d8e9dd9641fcc$var$load("jhykh").then(()=>parcelRequire('5FrU9'));

});

parcelRegister("i8l6a", function(module, exports) {

let $d33957119ac48327$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d33957119ac48327$var$load("150WG").then(()=>parcelRequire('4U2eK'));

});


parcelRegister("lK21m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c51a656e7f0274$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e5c51a656e7f0274$var$messages = (0, $7qGN1.defineMessages)({
    autoProvisionedSwitcherItemConfluenceDescription: {
        id: 'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription',
        defaultMessage: 'Document collaboration',
        description: 'When a user gets auto-provisioned Confluence, this is the text that will be in the description of the new Switcher Item'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    atlassianStartAriaLabel: {
        id: 'fabric.atlassianSwitcher.startAriaLabel',
        defaultMessage: 'Atlassian Start opens in a new tab',
        description: 'Aria-label for a link redirecting the user to the Start site'
    },
    switchTo: {
        id: 'fabric.atlassianSwitcher.switchTo',
        defaultMessage: 'Switch to',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    switchToTooltip: {
        id: 'fabric.atlassianSwitcher.switchToTooltip',
        defaultMessage: "Switch to\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    yourApps: {
        id: 'fabric.atlassianSwitcher.yourApps',
        defaultMessage: 'Your apps',
        description: 'In a context in which users are able to switch between products, this text is the title of the category displaying the products the user is able to switch to.'
    },
    yourAppsTooltip: {
        id: 'fabric.atlassianSwitcher.yourAppsTooltip',
        defaultMessage: "Your apps\u2026",
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    switchSitesOrAppsTooltip: {
        id: 'fabric.atlassianSwitcher.switchSitesOrAppsTooltip',
        defaultMessage: 'Switch sites or apps',
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    jwmInactiveSwitcherWithJSWItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription',
        defaultMessage: 'Manage business projects, free with Jira Software',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated and they have a Jira Software License'
    },
    jwmInactiveSwitcherWithDefaultItemDescription: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription',
        defaultMessage: 'Manage projects for business teams',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated'
    },
    organisationsLabel: {
        id: 'fabric.atlassianSwitcher.organisationsLabel',
        defaultMessage: 'Organisations',
        description: 'The label of organisation tab list'
    },
    switcherModalLabel: {
        id: 'fabric.atlassianSwitcher.modalLabel',
        defaultMessage: 'Atlassian App Switcher',
        description: 'The label of the switcher modal'
    },
    resizeBarLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarLabel',
        defaultMessage: 'Resize app switcher',
        description: 'The label of the resize bar'
    },
    resizeBarTooltipCollapsed: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipCollapsed',
        defaultMessage: 'Drag to resize{separator}Press to expand',
        description: 'The label of the resize bar tooltip when in collapsed state'
    },
    resizeBarTooltipExpanded: {
        id: 'fabric.atlassianSwitcher.resizeBarTooltipExpanded',
        defaultMessage: 'Drag to resize{separator}Press to collapse',
        description: 'The label of the resize bar tooltip when in expanded state'
    },
    resizeBarValueTextLabel: {
        id: 'fabric.atlassianSwitcher.resizeBarValueTextLabel',
        defaultMessage: 'Width',
        description: 'The value text label of the resize bar'
    },
    joinStatusText: {
        id: 'fabric.atlassianSwitcher.joinStatusText',
        defaultMessage: 'Join',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    instantAccessStatusText: {
        id: 'fabric.atlassianSwitcher.instantAccessStatusText',
        defaultMessage: 'Instant access',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    joinTeamStatusText: {
        id: 'fabric.atlassianSwitcher.joinTeamStatusText',
        defaultMessage: 'Join team',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    jpdDescriptionText: {
        id: 'fabric.atlassianSwitcher.jpdDescriptionText',
        defaultMessage: 'Prioritize and plan new ideas',
        description: 'The description displayed for Jira Product Discovery.'
    },
    confluenceDescriptionText: {
        id: 'fabric.atlassianSwitcher.confluenceDescriptionText',
        defaultMessage: 'Document and collaborate',
        description: 'The description displayed for Confluence.'
    },
    jiraDescriptionText: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    jsmDescriptionText: {
        id: 'fabric.atlassianSwitcher.jsmDescriptionText',
        defaultMessage: 'Automate and deliver IT support',
        description: 'The description displayed for Jira Service Management.'
    },
    requestAccessStatusText: {
        id: 'fabric.atlassianSwitcher.requestAccessStatusText',
        defaultMessage: 'Request access',
        description: 'The text displayed alongside a product to indicate the user can request access for the product.'
    },
    requestSentStatusText: {
        id: 'fabric.atlassianSwitcher.requestSentStatusText',
        defaultMessage: 'Request sent',
        description: 'The text displayed alongside a product to indicate the user has requested access to the product.'
    },
    requestAccessPendingRequestFlagTitle: {
        id: 'fabric.atlassianSwitcher.successFlag.title',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to a product but the request is pending.'
    },
    requestAccessPendingRequestFlagDescription: {
        id: 'fabric.atlassianSwitcher.successFlag.description',
        defaultMessage: "You'll get an email once it's approved",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    requestAccessPendingRequestFlagErrorTitle: {
        id: 'fabric.atlassianSwitcher.errorFlag.title',
        defaultMessage: `We couldn't add you to {product}`,
        description: 'Title shown when user has requested access to a product but the request has failed.'
    },
    requestAccessPendingRequestFlagErrorDescription: {
        id: 'fabric.atlassianSwitcher.errorFlag.description',
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    // TBLZ-2123: Growth - Trailblazers experiment - More info at go/trailblazerexperiments
    experimentNudgeToJiraConfluenceDescription: {
        id: 'fabric.atlassianSwitcher.experimentNudgeToJiraConfluenceDescription',
        defaultMessage: 'Bring your projects and pages closer',
        description: 'Description for Jira when viewed from Confluence to encourage using Jira and Confluence together'
    },
    experimentNudgeToJiraDescription: {
        id: 'fabric.atlassianSwitcher.experimentNudgeToJiraConfluenceDescription',
        defaultMessage: 'See work in lists, boards, or backlogs',
        description: 'Description for Jira to encourage using Jira together with other products'
    },
    reorderItemErrorFlagTitle: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagTitle',
        defaultMessage: 'Something went wrong',
        description: 'The title of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagDescription: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagDescription',
        defaultMessage: 'Please refresh the page or try again later.',
        description: 'The description of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagAction: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagAction',
        defaultMessage: 'Got it',
        description: 'The action of the error flag for reordering items in the switcher'
    }
});
var $e5c51a656e7f0274$export$2e2bcd8739ae039 = $e5c51a656e7f0274$var$messages;

});



parcelRegister("hZvWR", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderWithLoadingPopup", () => $e93f75f8c9c8190b$export$35c8740d616fd043);

var $eJOHy = parcelRequire("eJOHy");

var $jjS5D = parcelRequire("jjS5D");

var $lmgo6 = parcelRequire("lmgo6");
var $aewX5 = parcelRequire("aewX5");
var $1DXK0 = parcelRequire("1DXK0");

var $7aCti = parcelRequire("7aCti");

var $cNe2t = parcelRequire("cNe2t");

var $axnxR = parcelRequire("axnxR");
function $e93f75f8c9c8190b$export$35c8740d616fd043() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e93f75f8c9c8190b$var$SkeletonContent, null),
        isOpen: true,
        messageId: "navigation-apps-topnav4-app-switcher.ui.trigger.popup.loading.popup",
        messageType: "transactional",
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: $e93f75f8c9c8190b$var$Trigger
    });
}
function $e93f75f8c9c8190b$var$Trigger(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aCti.AppSwitcher), {
        ...triggerProps,
        label: (0, $axnxR.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    });
}
function $e93f75f8c9c8190b$var$SkeletonContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        xcss: $e93f75f8c9c8190b$var$containerStyles,
        rowGap: "space.200",
        columnGap: "space.150",
        templateColumns: "32px 1fr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e93f75f8c9c8190b$var$SkeletonItems, null));
}
function $e93f75f8c9c8190b$var$SkeletonItems() {
    return Array.from({
        length: 5
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "32px",
            height: "32px",
            isShimmering: true,
            borderRadius: "8px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "100%",
            height: "10px",
            isShimmering: true,
            borderRadius: "4px"
        }))));
}
const $e93f75f8c9c8190b$var$containerStyles = (0, $1DXK0.xcss)({
    width: '250px',
    padding: 'space.200'
});

});
parcelRegister("jjS5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae57afee648db5cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ae57afee648db5cf$var$shimmerKeyframes = null;
const $ae57afee648db5cf$var$skeletonStyles = null;
const $ae57afee648db5cf$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $ae57afee648db5cf$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hcewu.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq1y0p"
        ])
    });
};
var $ae57afee648db5cf$export$2e2bcd8739ae039 = $ae57afee648db5cf$var$Skeleton;

});

parcelRegister("aewX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f21aa3b401eee46$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $gF73L = parcelRequire("gF73L");

var $1DXK0 = parcelRequire("1DXK0");
function $5f21aa3b401eee46$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5f21aa3b401eee46$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $5f21aa3b401eee46$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $5f21aa3b401eee46$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $5f21aa3b401eee46$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $5f21aa3b401eee46$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $5f21aa3b401eee46$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $5f21aa3b401eee46$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $5f21aa3b401eee46$var$baseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$5f21aa3b401eee46$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$5f21aa3b401eee46$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$5f21aa3b401eee46$var$gridTemplateRowsVar})`
});
const $5f21aa3b401eee46$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $5f21aa3b401eee46$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $eJOHy.useMemo)(()=>({
            [$5f21aa3b401eee46$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$5f21aa3b401eee46$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$5f21aa3b401eee46$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $5f21aa3b401eee46$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $gF73L.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $gF73L.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $gF73L.spaceStylesMap).rowGap[rowGap],
            alignItems && $5f21aa3b401eee46$var$alignItemsMap[alignItems],
            alignContent && $5f21aa3b401eee46$var$alignContentMap[alignContent],
            justifyContent && $5f21aa3b401eee46$var$justifyContentMap[justifyContent],
            autoFlow && $5f21aa3b401eee46$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$5f21aa3b401eee46$var$Grid.displayName = 'Grid';
var $5f21aa3b401eee46$export$2e2bcd8739ae039 = $5f21aa3b401eee46$var$Grid;

});





$parcel$global.rlb("d1eff")
//# sourceMappingURL=ui.0db07f99.js.map
